import { useEffect, useState, useCallback, useRef, Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { ATT_REFRESH_EVENT } from "../../components/NewMessageNotifier";
import { warnDuplicateSinistro } from "../../lib/checkSinistro";
import api, { formatApiError } from "../../lib/api";
import { guardCreate } from "../../context/DuplicateGuard";
import { useAuth } from "../../context/AuthContext";
import MessageThread from "../../components/MessageThread";
import AllegatiDialog from "../../components/AllegatiDialog";
import DecodificaCFButton from "../../components/DecodificaCFButton";
import CostiDialog from "../../components/CostiDialog";
import QuietanzeDialog from "../../components/QuietanzeDialog";
import { SegnalatoreAnagWarning } from "../../components/SegnalatoreAnagWarning";
import WhatsAppDialog from "../../components/WhatsAppDialog";
import WhatsAppLink, { WaGlyph, cellOptions } from "../../components/WhatsAppLink";import GestioneLettereDialog from "../../components/GestioneLettereDialog";
import DocumentoDialog from "../../components/DocumentoDialog";
import FatturaDialog from "../../components/FatturaDialog";
import ProformaDialog from "../../components/ProformaDialog";
import ProformaPreviewDialog from "../../components/ProformaPreviewDialog";
import ProformaListDialog from "../../components/ProformaListDialog";
import ControparteDialog from "../../components/ControparteDialog";
import AssistitoDialog from "../../components/AssistitoDialog";
import { isMinore, etaAnni } from "../../lib/eta";
import StatoAggiuntivoField from "../../components/StatoAggiuntivoField";
import DiarioDialog from "../../components/DiarioDialog";
import PraticaComunicazioni from "../../components/PraticaComunicazioni";
import QuantificazioneDialog from "../../components/QuantificazioneDialog";
import GestioneOffertaDialog from "../../components/GestioneOffertaDialog";
import ProSelect from "../../components/ProSelect";
import SubjectPicker from "../../components/SubjectPicker";
import SubjectSelect from "../../components/SubjectSelect";
import AutocompleteInput from "../../components/AutocompleteInput";
import AddressAutocomplete from "../../components/AddressAutocomplete";
import DateInput from "../../components/DateInput";
import Combobox, { DOC_TIPI, DOC_RILASCIATO } from "../../components/Combobox";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import ProAnagField from "../../components/ProAnagField";
import { ContattiInline } from "../../components/ContattiInline";
import IspettoratoSelect from "../../components/IspettoratoSelect";
import CompagniaPraticaInfo from "../../components/CompagniaPraticaInfo";
import CollaboratoreField from "../../components/CollaboratoreField";
import CollabStudioField from "../../components/CollabStudioField";
import MultiCellulare from "../../components/MultiCellulare";
import IstruttoreField from "../../components/IstruttoreField";
import { PraticaWaTextContext } from "../../components/PraticaSummaryChips";
import NuovoProfessionistaDialog from "../../components/NuovoProfessionistaDialog";
import DatiSinistroDialog from "../../components/DatiSinistroDialog";
import PecDialog from "../../components/PecDialog";
import EmailDialog from "../../components/EmailDialog";
import { PRO_FIELDS, PRO_ATYPES, COND_PRO_FIELDS } from "../../lib/proFields";
import { fetchTipologie, tipoFlags } from "../../lib/tipologieSinistro";
import { displayName } from "../../lib/anagConfig";
import { DEF_TIPI, defTipo, defLabel } from "../../lib/definita";
import { useDisabledModules } from "../../lib/moduli";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";
import { formatDate } from "../../lib/format";
import { CodiceFiscale } from "codice-fiscale-js";
import { buildCopertina } from "../../lib/copertina";
import { downloadPdf } from "../../lib/letterPdf";
import { buildCaiCid, buildCaiCidUfficiale, praticaToCaiForm } from "../../lib/caicid";
import PdfPreviewModal from "../../components/PdfPreviewModal";
import CaiCidEditModal from "../../components/CaiCidEditModal";
import CaiCidOptionsDialog from "../../components/CaiCidOptionsDialog";
import { FileDown } from "lucide-react";
import { Copy, Link2, Share2 } from "lucide-react";
import ShareCreateDialog from "../../components/condivisioni/ShareCreateDialog";
import { Archive } from "lucide-react";
import { Lock, Unlock } from "lucide-react";
import { Checkbox } from "../../components/ui/checkbox";
import DuplicaPraticaDialog from "../../components/DuplicaPraticaDialog";
import SoggettoBell from "../../components/SoggettoBell";
import { AreaStatusBadge } from "../../components/AreaStatusBadge";
import CollegaPraticaField from "../../components/CollegaPraticaField";
import { Badge } from "../../components/ui/badge";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../components/ui/sheet";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter, AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel } from "../../components/ui/alert-dialog";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import {
  ArrowLeft, Trash2, Pencil, BookText, MessageCircle, MessageSquare, Calculator, Hammer,
  UserSearch, FileBarChart, BadgeEuro, ReceiptText, MailCheck, Mail, Mails, FileText,
  Paperclip, Globe, AlertTriangle, ShieldAlert, Coins, Receipt, Plus, ChevronUp, ChevronDown, Users, RefreshCw, CalendarPlus, Loader2,
  Phone, Smartphone,
} from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../../components/ui/tooltip";
import { AppuntamentoDialog } from "./Agenda";
import { toast } from "sonner";
import { useNonAderenti } from "../../lib/convenzione";
import { ProfessionistiDialog } from "../../components/ProfessionistiDialog";

const STATO = { aperta: "Aperta", in_lavorazione: "In Lavorazione", legale: "Legale", mediazione: "Mediazione", chiusa: "Chiusa", out: "S.S." };
const STATO_OPZIONI = [
  { v: "in_lavorazione", l: "In Lavorazione" },
  { v: "aperta", l: "Aperta" },
  { v: "chiusa", l: "Chiusa" },
  { v: "out", l: "Senza Seguito (S.S.)" },
];
const STATO_STYLE = {
  aperta: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  in_lavorazione: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  legale: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  mediazione: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
  chiusa: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  out: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};
const V = (x) => (x === 0 ? "0" : x || "—");
const CompagniaHead = ({ compagnia, gest, testId }) => (compagnia ? (
  <span className="flex items-center gap-1.5 min-w-0 normal-case" data-testid={testId}>
    <span className="text-xs font-semibold text-slate-300 truncate max-w-[260px]" title={compagnia}>· {compagnia}</span>
    {gest && <span className="shrink-0 rounded-full px-2 py-0.5 text-[9px] font-extrabold tracking-wider" style={{ background: "#22c55e", color: "#052e16" }} data-testid={`${testId}-gestionaria`}>GESTIONARIA</span>}
  </span>
) : null);

// Testo completo autorità intervenute ('<tipo> di <città>'), coerente col backend _autorita_full.
const autoritaFull = (p) => {
  const tipo = String(p?.autorita_tipo || "").trim();
  const citta = String(p?.autorita_di || "").trim();
  if (tipo) return citta ? `${tipo} di ${citta}` : tipo;
  const raw = String(p?.autorita_intervenute || "").trim();
  return ["SI", "NO", ""].includes(raw.toUpperCase()) ? "" : raw;
};

function Field({ label, value, mono, alt, children, testId, highlight }) {
  return (
    <div data-testid={testId} className="grid grid-cols-[40%_60%] border-b border-slate-300 last:border-0">
      <div className={`font-bold uppercase text-[11px] tracking-wide px-3 py-2 leading-snug break-words flex items-center ${highlight ? "bg-amber-600 text-white" : "bg-slate-800 text-white"}`}>{label}</div>
      <div className={`px-3 py-2 text-sm text-left leading-snug break-words flex items-center ${highlight ? "bg-amber-50 text-black font-semibold" : `text-slate-900 ${alt ? "bg-slate-100" : "bg-white"}`} ${mono ? "font-mono" : ""}`}>{children ?? value}</div>
    </div>
  );
}

// Riga editabile con lo stesso stile di Field (etichetta scura, valore chiaro); lighting dei controlli via arbitrary variants.
function AField({ label, children, alt, highlight }) {
  return (
    <div className="grid grid-cols-[40%_60%] border-b border-slate-300 last:border-0">
      <div className={`font-bold uppercase text-[11px] tracking-wide px-3 py-2 leading-snug break-words flex items-center ${highlight ? "bg-amber-600 text-white" : "bg-slate-800 text-white"}`}>{label}</div>
      <div className={`px-3 py-2 flex items-center ${highlight ? "bg-amber-50" : (alt ? "bg-slate-100" : "bg-white")} [&_input]:bg-white [&_input]:text-slate-900 [&_input]:border-slate-300 [&_[role=combobox]]:bg-white [&_[role=combobox]]:text-slate-900 [&_[role=combobox]]:border-slate-300 [&>div]:!mt-0 [&>div]:w-full`}>{children}</div>
    </div>
  );
}

const ACTION_COLORS = {
  "Cancella": "#dc2626",
  "Modifica": "#2563eb",
  "Diario": "#14532d",
  "Messaggi": "#0ea5e9",
  "SMS": "#25d366",
  "Quantifica": "#f97316",
  "Ricostruisci": "#475569",
  "Periziatore": "#7c3aed",
  "PML": "#06b6d4",
  "Offerta": "#d4af37",
  "Quietanza": "#34d399",
  "PEC": "#1e3a8a",
  "Email": "#38bdf8",
  "Lettere": "#c2410c",
  "Allegati": "#546e7a",
  "Web": "#4f46e5",
  "Reclamo": "#a83232",
  "Anti frode": "#be185d",
  "Costi": "#92400e",
  "Fattura": "#556b2f",
  "Comunicazioni": "#2563eb",
};

function CtxToolbar({ items, testId }) {
  return (
    <div className="px-4 py-3 border-b border-slate-800 bg-slate-900/50" data-testid={testId}>
      <div className="flex flex-wrap gap-1.5">
        {items.map((a) => {
          const tid = `${testId}-${a.label.toLowerCase().replace(/\s+/g, "-")}`;
          return (
          <button key={a.label} onClick={a.on} data-testid={tid}
            style={{ backgroundColor: ACTION_COLORS[a.label] || "#334155" }}
            className="relative flex flex-col items-center justify-center gap-1 w-[70px] h-[58px] rounded-lg border border-transparent text-white transition-opacity hover:opacity-90">
            <a.icon className="h-5 w-5 text-white" />
            {a.labelLines ? (
              <span className="text-[10px] font-medium leading-tight text-center text-white">
                {a.labelLines.map((l, idx) => <span key={idx} className="block">{l}</span>)}
              </span>
            ) : (
              <span className="text-[11px] font-medium leading-none text-center text-white">{a.label}</span>
            )}
            {a.badge > 0 && (
              <span data-testid={`${tid}-badge`}
                className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center border-2 border-[#0d1220] shadow">
                {a.badge > 99 ? "99+" : a.badge}
              </span>
            )}
          </button>
          );
        })}
      </div>
    </div>
  );
}

const ASSISTITO_FIELDS = [
  "nome_assistito", "codice_fiscale", "targa", "compagnia",
  "assistito_ragione_sociale", "assistito_ruolo", "assistito_ispettorato",
  "assistito_liquidatore", "assistito_perito_compagnia", "assistito_perito_parte", "assistito_medico_legale",
  "assistito_accertatore", "assistito_riparatore", "assistito_legale", "assistito_istruttore",
];

const TESTIMONE_EMPTY = {
  cognome: "", nome: "", sesso: "", data_nascita: "", comune_nascita: "", comune_nascita_prov: "", codice_fiscale: "",
  professione: "", cellulare: "", cellulari_extra: [], cellulari_etichette: [], telefono: "", indirizzo: "", numero_civico: "", comune: "", cap: "", provincia: "",
  tipo_documento: "", numero_documento: "", documento_rilasciato_da: "", doc_luogo_rilascio: "", doc_data_rilascio: "", doc_data_scadenza: "",
};

// Scheda conducente collegata al soggetto: domanda Sì/No + campi editabili quando "Sì".
function CopyBtn({ value, testId }) {
  const copy = async (e) => {
    e.stopPropagation();
    const text = String(value || "");
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.focus(); ta.select();
      try { document.execCommand("copy"); } catch { /* noop */ }
      ta.remove();
    }
    toast.success("Copiato!");
  };
  return (
    <button type="button" onClick={copy} data-testid={testId} title="Copia negli appunti"
      className="opacity-0 group-hover/num:opacity-100 focus:opacity-100 transition-opacity inline-flex items-center justify-center h-5 w-5 rounded hover:bg-slate-700/60 text-slate-400 hover:text-slate-100">
      <Copy className="h-3 w-3" />
    </button>
  );
}

const parseDMY = (s) => {
  if (!s) return null;
  const t = String(s).trim();
  let m;
  if ((m = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/))) return { d: +m[3], mo: +m[2], y: +m[1] };
  if ((m = t.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/))) return { d: +m[1], mo: +m[2], y: +m[3] };
  if ((m = t.match(/^(\d{2})(\d{2})(\d{4})$/))) return { d: +m[1], mo: +m[2], y: +m[3] };
  return null;
};
const toISODate = (s) => {
  const dmy = parseDMY(s);
  if (!dmy) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${dmy.y}-${pad(dmy.mo)}-${pad(dmy.d)}`;
};
const normSesso = (v) => {
  const s = String(v || "").trim().toUpperCase();
  if (s.startsWith("M")) return "M";
  if (s.startsWith("F")) return "F";
  if (s.startsWith("A")) return "Altro";
  return "";
};

function TestimoneDialog({ open, onOpenChange, initial, onSave }) {
  const [f, setF] = useState(TESTIMONE_EMPTY);
  const [cfTouched, setCfTouched] = useState(false);
  useEffect(() => {
    if (!open) return;
    const next = Object.fromEntries(Object.keys(TESTIMONE_EMPTY).map((k) => [k, initial?.[k] || ""]));
    next.sesso = normSesso(next.sesso);
    next.data_nascita = toISODate(next.data_nascita) || next.data_nascita;
    setF(next);
    setCfTouched(false);
  }, [open, initial]);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const computeCF = () => {
    const dmy = parseDMY(f.data_nascita);
    if (!f.nome || !f.cognome || !f.sesso || f.sesso === "Altro" || !f.comune_nascita || !dmy) return null;
    try {
      return new CodiceFiscale({
        name: f.nome, surname: f.cognome, gender: f.sesso === "F" ? "F" : "M",
        day: dmy.d, month: dmy.mo, year: dmy.y, birthplace: f.comune_nascita,
        birthplaceProvincia: (f.comune_nascita_prov || "").toUpperCase() || undefined,
      }).toString();
    } catch (e) { return null; }
  };
  // Ricalcolo automatico del CF a ogni modifica dei dati anagrafici, finché non si modifica il CF a mano
  useEffect(() => {
    if (cfTouched) return;
    const cf = computeCF();
    if (cf) setF((s) => (s.codice_fiscale === cf ? s : { ...s, codice_fiscale: cf }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [f.nome, f.cognome, f.sesso, f.data_nascita, f.comune_nascita, f.comune_nascita_prov, cfTouched]);
  const ricalcolaCF = () => {
    const cf = computeCF();
    if (cf) { setF((s) => ({ ...s, codice_fiscale: cf })); setCfTouched(false); }
    else toast.error("Impossibile calcolare il CF: compila nome, cognome, sesso, data e comune di nascita");
  };
  const salva = () => {
    if (!f.cognome && !f.nome) { toast.error("Inserisci cognome o nome del testimone"); return; }
    const nominativo = [f.cognome, f.nome].filter(Boolean).join(" ").trim();
    onSave({ ...(initial || {}), ...f, nominativo });
  };
  const LBL = "block text-[11px] uppercase tracking-wider text-slate-400 font-mono mb-1";
  const wrap = (label, node, extra) => (
    <label className="text-sm"><span className={`${LBL} ${extra ? "inline-flex items-center gap-1.5" : ""}`}>{label}{extra || null}</span>{node}</label>
  );
  const txt = (label, k, opts = {}) => wrap(label,
    <Input value={f[k]} onChange={(e) => set(k, opts.up ? e.target.value.toUpperCase() : e.target.value)}
      data-testid={`testimone-${k}`} className="h-9 w-full" {...(opts.inputProps || {})} />,
    opts.wa ? <WhatsAppLink number={f[k]} size="h-3.5 w-3.5" testId={`testimone-${k}-wa`} /> : null);
  const sel = (label, k, options) => wrap(label,
    <select value={f[k]} onChange={(e) => set(k, e.target.value)} data-testid={`testimone-${k}`}
      className="h-9 w-full rounded-md bg-slate-900/60 border border-slate-700 text-slate-100 text-sm px-2 focus:outline-none focus:ring-1 focus:ring-sky-500/40">
      <option value="" className="bg-[#121824]">—</option>
      {options.map((o) => <option key={o} value={o} className="bg-[#121824]">{o}</option>)}
    </select>);
  const auto = (label, k, onItem) => wrap(label,
    <AutocompleteInput value={f[k]} onChange={(v) => set(k, v)} source="comuni" onSelectItem={onItem} testId={`testimone-${k}`} />);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-2xl max-h-[88vh] overflow-y-auto" data-testid="testimone-dialog">
        <DialogHeader>
          <DialogTitle className="font-head">{initial ? "Modifica testimone" : "Nuovo testimone"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <div>
            <div className="text-[11px] uppercase tracking-wider text-sky-300 font-mono mb-2">Dati anagrafici</div>
            <div className="grid sm:grid-cols-2 gap-3">
              {txt("Cognome", "cognome")}
              {txt("Nome", "nome")}
              {sel("Sesso", "sesso", ["M", "F", "Altro"])}
              {wrap("Data di nascita",
                <DateInput value={f.data_nascita} onChange={(iso) => set("data_nascita", iso)} testId="testimone-data_nascita" className="h-9 bg-slate-900/60 border-slate-700" />)}
              {auto("Comune di nascita", "comune_nascita", (it) => set("comune_nascita_prov", it.provincia || ""))}
              {txt("Provincia di nascita", "comune_nascita_prov", { up: true, inputProps: { placeholder: "Es. RM", maxLength: 2 } })}
              <label className="text-sm">
                <span className={LBL}>Codice Fiscale <span className="text-slate-500 normal-case">(auto, modificabile)</span></span>
                <div className="flex items-center gap-1.5">
                  <Input value={f.codice_fiscale} onChange={(e) => { setCfTouched(true); set("codice_fiscale", e.target.value.toUpperCase()); }}
                    data-testid="testimone-codice_fiscale" className="h-9 flex-1 font-mono" />
                  <button type="button" onClick={ricalcolaCF} data-testid="testimone-ricalcola-cf" title="Ricalcola codice fiscale"
                    className="h-9 w-9 shrink-0 flex items-center justify-center rounded-md border border-sky-500/40 text-sky-300 hover:bg-sky-500/10 transition-colors">
                    <RefreshCw className="h-4 w-4" />
                  </button>
                  <DecodificaCFButton cf={f.codice_fiscale} testId="testimone-decodifica-cf" className="h-9 shrink-0"
                    onDecode={(d) => { set("sesso", d.sesso); set("data_nascita", d.data_nascita); set("comune_nascita", d.comune_nascita); set("comune_nascita_prov", d.provincia_nascita); if (!f.cognome) set("cognome", d.cognomeCode); if (!f.nome) set("nome", d.nomeCode); }} />
                </div>
              </label>
              {txt("Professione", "professione")}
              <div className="text-sm"><span className={`${LBL} inline-flex items-center gap-1.5`}>Cellulare<WhatsAppLink number={f.cellulare} size="h-3.5 w-3.5" testId="testimone-cellulare-wa" /></span>
                <MultiCellulare extra={f.cellulari_extra} onExtra={(v) => set("cellulari_extra", v)} labels={f.cellulari_etichette} onLabels={(v) => set("cellulari_etichette", v)} testId="testimone-cellulare">
                  <Input value={f.cellulare || ""} onChange={(e) => set("cellulare", e.target.value)} data-testid="testimone-cellulare" className="h-9 w-full" />
                </MultiCellulare>
              </div>
              {txt("Telefono", "telefono")}
            </div>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-wider text-sky-300 font-mono mb-2">Residenza</div>
            <div className="space-y-3">
              {wrap("Indirizzo",
                <AddressAutocomplete value={f.indirizzo} onChange={(v) => set("indirizzo", v)}
                  onPick={(pk) => setF((s) => ({ ...s, indirizzo: pk.indirizzo, comune: pk.comune, cap: pk.cap, provincia: pk.provincia }))}
                  city={f.comune} prov={f.provincia} testId="testimone-indirizzo" />)}
              <div className="grid sm:grid-cols-4 gap-3">
                {txt("N° Civ.", "numero_civico")}
                {auto("Comune", "comune", (it) => { set("provincia", it.provincia || ""); set("cap", it.cap || ""); })}
                {txt("CAP", "cap")}
                {txt("Provincia", "provincia", { up: true, inputProps: { maxLength: 2 } })}
              </div>
            </div>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-wider text-sky-300 font-mono mb-2">Documento</div>
            <div className="grid sm:grid-cols-2 gap-3">
              {wrap("Tipo documento", <Combobox value={f.tipo_documento} onChange={(v) => set("tipo_documento", v)} options={DOC_TIPI} testId="testimone-tipo_documento" />)}
              {txt("Numero documento", "numero_documento")}
              {wrap("Rilasciato da", <Combobox value={f.documento_rilasciato_da} onChange={(v) => set("documento_rilasciato_da", v)} options={DOC_RILASCIATO} testId="testimone-documento_rilasciato_da" />)}
              {txt("Luogo di rilascio", "doc_luogo_rilascio")}
              {wrap("Data rilascio", <DateInput value={f.doc_data_rilascio} onChange={(iso) => set("doc_data_rilascio", iso)} testId="testimone-doc_data_rilascio" className="h-9 bg-slate-900/60 border-slate-700" />)}
              {wrap("Data scadenza", <DateInput value={f.doc_data_scadenza} onChange={(iso) => set("doc_data_scadenza", iso)} testId="testimone-doc_data_scadenza" className="h-9 bg-slate-900/60 border-slate-700" />)}
            </div>
          </div>
        </div>
        <DialogFooter>
          <button type="button" onClick={() => onOpenChange(false)} data-testid="testimone-cancel" className="text-sm rounded-md border border-slate-700 bg-slate-800/60 text-slate-200 hover:bg-slate-700 px-3 py-1.5 transition-colors">Annulla</button>
          <button type="button" onClick={salva} data-testid="testimone-save" className="text-sm rounded-md bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-3 py-1.5 transition-colors">{initial ? "Aggiorna testimone" : "Salva testimone"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default function PraticaDetail({ pratica, onBack, backLabel, onEdit, onDelete, onGenerate, onSaved, onOpenPratica, onDuplicated, onArchived }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "titolare" || user?.role === "amministratore";
  const [p, setP] = useState(pratica);
  const [duplicaOpen, setDuplicaOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [appuntamentoOpen, setAppuntamentoOpen] = useState(false);
  const [allegatiOpen, setAllegatiOpen] = useState(false);
  const [waOpen, setWaOpen] = useState(false);
  const [waClient, setWaClient] = useState(null);
  const offMods = useDisabledModules();
  const [waNum, setWaNum] = useState("");
  const [allegatiClient, setAllegatiClient] = useState(null);
  const [lettereClient, setLettereClient] = useState(null);
  const [costiOpen, setCostiOpen] = useState(false);
  const [quietanzeOpen, setQuietanzeOpen] = useState(false);
  const [quietanzeClient, setQuietanzeClient] = useState(null);
  const [quietanzeIndex, setQuietanzeIndex] = useState("principal");
  const [lettereOpen, setLettereOpen] = useState(false);
  const [assistitoOpen, setAssistitoOpen] = useState(false);
  const [cpOpen, setCpOpen] = useState({});
  const [doc, setDoc] = useState(null);        // { title, content }
  const [fatturaOpen, setFatturaOpen] = useState(false);
  const [proformaOpen, setProformaOpen] = useState(false);
  const [proformaListOpen, setProformaListOpen] = useState(false);
  const [proformaClient, setProformaClient] = useState(null);
  const [proformaClientKey, setProformaClientKey] = useState(null);
  const [previewProforma, setPreviewProforma] = useState(null);
  const [proformaStudio, setProformaStudio] = useState(null);
  const [diarioOpen, setDiarioOpen] = useState(false);
  const [diarioClient, setDiarioClient] = useState(null);
  const [messaggiOpen, setMessaggiOpen] = useState(false);
  const [comunicazioniOpen, setComunicazioniOpen] = useState(false);
  const [comUnread, setComUnread] = useState(0);
  const comPrevUnread = useRef(null);
  const [quantOpen, setQuantOpen] = useState(false);
  const [offertaOpen, setOffertaOpen] = useState(false);
  const [offertaAccettata, setOffertaAccettata] = useState(false);
  const [copPreview, setCopPreview] = useState(null); // { url, doc, filename }
  const [copPec, setCopPec] = useState(null); // { d, m, y } dialog data PEC copertina
  const [copModelsList, setCopModelsList] = useState([]);
  const [copModelSel, setCopModelSel] = useState("__default__");
  useEffect(() => {
    if (copPec) api.get("/studio/me").then(({ data }) => setCopModelsList(Array.isArray(data.settings?.copertina_models) ? data.settings.copertina_models : [])).catch(() => {});
  }, [copPec]);
  const [copGen, setCopGen] = useState(false);

  const generaCopertina = async (pecDate) => {
    setCopGen(true);
    try {
      const pad = (v, n) => String(v || "").padStart(n, "0");
      const pecStr = (pecDate && (pecDate.d || pecDate.m || pecDate.y))
        ? `${pad(pecDate.d, 2)}/${pad(pecDate.m, 2)}/${pad(pecDate.y, 4)}`
        : "";
      // Persiste la data PEC sulla pratica: così {{copertina.data_pec}} è disponibile anche nelle lettere/template.
      if ((p.copertina_data_pec || "") !== pecStr) {
        try { await patchP({ copertina_data_pec: pecStr }, { force: true }); } catch { /* non blocca la generazione copertina */ }
      }
      const { data } = await api.get("/studio/me");
      // Modalità template: se lo studio ha personalizzato la copertina, usa il template salvato
      // sostituendo le variabili con i valori reali della pratica (resa lato backend).
      const _settings = data.settings || {};
      const _models = Array.isArray(_settings.copertina_models) ? _settings.copertina_models : [];
      const _model = copModelSel !== "__default__" ? _models.find((m) => m.id === copModelSel) : null;
      const _tmpl = ((_model ? _model.template : _settings.copertina_template) || "").trim();
      if (_tmpl) {
        const { data: rend } = await api.post(`/studio/pratiche/${p.id}/copertina-html`, { content: _tmpl, data_pec: pecStr });
        const pm = _settings.print_margins;
        const margins = (pm && typeof pm.top === "number") ? pm : { top: 20, right: 15, bottom: 15, left: 20 };
        const fname = `Copertina_${(p.numero_pratica || "pratica").replace(/[^\p{L}\p{N}\-_]+/gu, "_")}.pdf`;
        const doc = await downloadPdf(fname, rend.content || _tmpl, false, null, margins, { returnDoc: true, footer: _settings.pdf_footer !== false });
        setCopPec(null);
        setCopPreview({ doc, filename: fname });
        return;
      }
      const extra = {};
      const norm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");
      const segName = (p.segnalatore || "").trim();
      if (segName) {
        try {
          const { data: segs } = await api.get(`/anagrafiche/segnalatori?q=${encodeURIComponent(segName)}`);
          const rec = (segs || []).find((r) => norm(displayName(r)) === norm(segName)
            || norm([r.nome, r.cognome].filter(Boolean).join(" ")) === norm(segName)
            || norm([r.cognome, r.nome].filter(Boolean).join(" ")) === norm(segName));
          if (rec && rec.solo_iniziali_copertina) extra._segnalatore_iniziali = true;
        } catch { /* opzionale */ }
      }
      const cands = [];
      const sched = (p.assistito_scheda && typeof p.assistito_scheda === "object") ? p.assistito_scheda : {};
      if (sched.cessionario && typeof sched.cessionario === "object") cands.push(sched.cessionario);
      (p.assistiti || []).forEach((a) => { if (a && typeof a.cessionario === "object" && a.cessionario) cands.push(a.cessionario); });
      const cess = cands.find((x) => x && Object.values(x).some((v) => String(v || "").trim())) || null;
      if (cess && cess.carrozzeria_id) {
        try {
          const { data: carr } = await api.get("/anagrafiche/carrozzieri");
          const rec = (carr || []).find((r) => r.id === cess.carrozzeria_id);
          if (rec && rec.solo_iniziali_copertina) extra._cessionario_iniziali = true;
        } catch { /* opzionale */ }
      }
      const pCop = Object.keys(extra).length ? { ...p, ...extra } : p;
      const _fields = _model ? _model.fields : data.settings?.copertina_fields;
      const _fstyles = _model ? _model.field_styles : data.settings?.copertina_field_styles;
      const { doc: cdoc, filename } = buildCopertina(pCop, { name: data.studio_name, ...(data.settings || {}) }, _fields, data.settings?.print_margins, _fstyles, pecDate);
      setCopPec(null);
      setCopPreview({ doc: cdoc, filename });
    } catch (e) { toast.error("Errore nella generazione della copertina"); }
    finally { setCopGen(false); }
  };
  const [caiPreview, setCaiPreview] = useState(null); // { doc, filename }
  const [caiChoose, setCaiChoose] = useState(null); // { form, studio }
  const [caiEdit, setCaiEdit] = useState(null); // { form, studio, modello }
  const [cpDialog, setCpDialog] = useState(null); // { index, data }
  const [aOpen, setAOpen] = useState({});
  const [aDialog, setADialog] = useState(null); // { index, data }
  const [testimoniOpen, setTestimoniOpen] = useState(false);
  const [webOpen, setWebOpen] = useState(false);
  const [tOpen, setTOpen] = useState({});
  const [tDialog, setTDialog] = useState(null); // { index, data }
  const [delTarget, setDelTarget] = useState(null); // { index, name }
  const [deleting, setDeleting] = useState(false);
  const [multiMatches, setMultiMatches] = useState({});
  const [collegate, setCollegate] = useState([]);
  const [collegateOpen, setCollegateOpen] = useState(false);
  const soon = (label) => toast.info(`${label}: funzione in arrivo`);

  useEffect(() => { setP(pratica); }, [pratica]);

  // All'apertura del modale testimoni, seleziona automaticamente il primo della lista (se presente).
  useEffect(() => {
    if (testimoniOpen) {
      const list = Array.isArray(p.testimoni) ? p.testimoni : [];
      setTOpen(list.length ? { 0: true } : {});
    }
  }, [testimoniOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let active = true;
    api.get(`/studio/pratiche/${p.id}/offerte`)
      .then(({ data }) => { if (active) setOffertaAccettata((data.offerte || []).some((o) => o.data_accettazione)); })
      .catch(() => {});
    return () => { active = false; };
  }, [p.id, offertaOpen]);

  const fetchComUnread = useCallback(async () => {
    try {
      const { data } = await api.get(`/studio/pratiche/${p.id}/comunicazioni`);
      const u = data.unread || 0;
      setComUnread(u);
      if (comPrevUnread.current !== null && u > comPrevUnread.current) {
        toast.info("Nuova comunicazione (Email/PEC) ricevuta per questa pratica");
      }
      comPrevUnread.current = u;
    } catch { /* ignore */ }
  }, [p.id]);

  useEffect(() => {
    comPrevUnread.current = null;
    fetchComUnread();
    const id = setInterval(fetchComUnread, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [fetchComUnread]);

  useEffect(() => {
    let active = true;
    api.get(`/studio/pratiche/${p.id}/soggetti-multipratica`).then(({ data }) => { if (active) setMultiMatches(data.matches || {}); }).catch(() => {});
    api.get(`/studio/pratiche/${p.id}/collegate`).then(({ data }) => { if (active) setCollegate(data || []); }).catch(() => {});
    return () => { active = false; };
  }, [p.id]);

  const [areaStatus, setAreaStatus] = useState([]);
  useEffect(() => {
    let active = true;
    const load = () => api.get(`/studio/pratiche/${p.id}/area-status`).then(({ data }) => { if (active) setAreaStatus(data || []); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, [p.id]);
  const areaFor = (c) => {
    const ks = [c.cliente_id, c.__principal && p.assistito_cliente_id, c.__principal && p.cliente_id, (c.email || "").trim().toLowerCase()].filter(Boolean).map(String);
    return areaStatus.find((s) => s.keys.some((k) => ks.includes(k))) || null;
  };

  const subjNorm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");
  const subjToken = (cf, name) => { const ncf = subjNorm(cf).replace(/\s+/g, ""); if (ncf) return `cf:${ncf}`; const nn = subjNorm(name); return nn ? `nm:${nn}` : null; };
  const subjMatches = (c) => multiMatches[subjToken(c.codice_fiscale, c.ragione_sociale || [c.cognome, c.nome].filter(Boolean).join(" "))] || null;
  const openCollegata = (pr) => { setCollegateOpen(false); onOpenPratica && onOpenPratica(pr.numero_pratica); };
  const doScollega = async () => {
    try {
      await api.post(`/studio/pratiche/${p.id}/scollega`);
      setCollegate([]); setCollegateOpen(false);
      toast.success("Pratica scollegata dal gruppo pratiche collegate");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const scollegaPratica = () => {
    toast("Scollegare questa pratica dal gruppo collegate?", {
      duration: 8000,
      action: { label: "Scollega", onClick: () => doScollega() },
      cancel: { label: "Annulla" },
    });
  };
  const collegaByTarget = async (pr) => {
    try {
      await api.post(`/studio/pratiche/${p.id}/collega`, { target_id: pr.id });
      const { data: list } = await api.get(`/studio/pratiche/${p.id}/collegate`);
      setCollegate(list || []);
      toast.success(`Pratica ${pr.numero_pratica} collegata`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const controparti = Array.isArray(p.controparti) ? p.controparti : [];
  const nonAderente = useNonAderenti();
  const [tipiList, setTipiList] = useState([]);
  useEffect(() => { fetchTipologie().then(setTipiList); }, []);
  const isRD = String(p.tipo || "").trim().toUpperCase() === "RD" && !nonAderente(controparti[0]?.compagnia || p.controparte_compagnia || "");
  const tFlags = tipoFlags(tipiList, p.tipo);
  const soloProf = tFlags.soloProf;
  const proFieldsVis = soloProf ? PRO_FIELDS.filter((pf) => ["assistito_medico_legale", "assistito_legale"].includes(pf.key)) : PRO_FIELDS;
  const assistiti = Array.isArray(p.assistiti) ? p.assistiti : [];
  const assistitoLabel = p.assistito_ragione_sociale || p.nome_assistito || p.cliente_nome || "Assistito";
  const [waSubject, setWaSubject] = useState(null);
  const hasPrincipal = !!(p.assistito_ragione_sociale || p.nome_assistito || p.cliente_nome || p.cliente_id);
  const condPersonName = (c) => (c && typeof c === "object" && c.is_cliente === false) ? ((c.nominativo || [c.cognome, c.nome].filter(Boolean).join(" ")) || "").trim() : "";

  const chiusa = p.stato === "chiusa";

  const patchP = async (updates, opts = {}) => {
    if (chiusa && !opts.force) {
      toast.error("Pratica chiusa: non modificabile. Riaprila per apportare modifiche.");
      throw new Error("pratica-chiusa");
    }
    try {
      const { data } = await api.patch(`/studio/pratiche/${p.id}`, updates);
      const merged = { ...p, ...updates, ...data };
      setP(merged);
      onSaved && onSaved(merged);
      return merged;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      throw e;
    }
  };

  const saveField = (key, value) => { patchP({ [key]: value }).then(() => toast.success("Campo salvato")).catch(() => {}); };
  const primaryClient = assistiti[0] || null;
  const inheritedCompagnia = primaryClient ? (primaryClient.assicurazione || primaryClient.compagnia || "") : "";
  const inheritedIspettorato = primaryClient ? (primaryClient.ispettorato || "") : "";
  // Compagnia/Ispettorato del cliente primario: prima il dato della sua scheda, poi eventuale override pratica.
  const compagniaAssistito = inheritedCompagnia || p.assistito_compagnia || p.compagnia || "";
  const ispettoratoAssistito = inheritedIspettorato || p.assistito_ispettorato || p.ispettorato || "";
  const waHour = new Date().getHours();
  const waSaluto = waHour >= 6 && waHour < 13 ? "Buongiorno" : waHour >= 13 && waHour < 18 ? "Buon pomeriggio" : "Buonasera";
  const waSinNum = String((isRD ? p.assistito_num_sinistro : controparti[0]?.num_sinistro) || "").trim();
  const waGestComp = String((isRD ? compagniaAssistito : (controparti[0]?.compagnia || p.controparte_compagnia)) || "").trim().toUpperCase();
  const waText = `${waSaluto}, la contatto in merito al sinistro${waSinNum ? ` n. ${waSinNum}` : ""}${waGestComp ? ` - ${waGestComp}` : ""} (Ns. rif. ${p.numero_pratica || ""}) - cliente ${assistitoLabel}.`;
  const waCtx = { text: waText, open: (s) => setWaSubject({ ...s, client: { ragione_sociale: s.nome, cell: s.numero, cellulari_etichette: [s.etichetta || ""] } }) };
  const savePrimary = (clientKey, praticaKey) => (value) => {
    if (primaryClient) {
      const arr = [...assistiti];
      arr[0] = { ...arr[0], [clientKey]: value };
      patchP({ assistiti: arr }).then(() => toast.success("Campo salvato")).catch(() => {});
    } else {
      saveField(praticaKey, value);
    }
  };

  // ---- Lista clienti unificata (indice 0 = principale) + riordino ----
  const clientKey = (c) => (c && c.cliente_id) ? String(c.cliente_id) : "principale";
  const namedAssistiti = assistiti.filter((a) => a.ragione_sociale || a.cliente_id || a.nome || a.cognome);
  const isGiurScheda = ["SI", "E"].includes(String(p.assistito_scheda?.soggetto_iva || "").toUpperCase());
  const principalEntry = hasPrincipal ? {
    ...(p.assistito_scheda || {}),
    __principal: true,
    cliente_id: p.cliente_id || (p.assistito_scheda?.cliente_id) || null,
    ragione_sociale: p.assistito_ragione_sociale || p.nome_assistito || p.cliente_nome || "",
    cognome: (p.assistito_scheda?.cognome) || (isGiurScheda ? (p.assistito_ragione_sociale || p.nome_assistito || "") : ((p.nome_assistito || p.assistito_ragione_sociale || "").trim().split(/\s+/)[0] || "")),
    nome: (p.assistito_scheda?.cognome || isGiurScheda) ? (p.assistito_scheda?.nome || "") : ((p.assistito_scheda?.nome) || ((p.nome_assistito || p.assistito_ragione_sociale || "").trim().split(/\s+/).slice(1).join(" ") || "")),
    ruolo: p.assistito_ruolo || (p.assistito_scheda?.ruolo) || "Assistito",
    targa: p.targa || (p.assistito_scheda?.targa) || (assistiti[0]?.targa) || "",
    compagnia: compagniaAssistito,
    assicurazione: compagniaAssistito,
    ispettorato: ispettoratoAssistito,
    num_sinistro: p.assistito_num_sinistro || "",
    istruttore: p.assistito_istruttore || "",
    ...Object.fromEntries(PRO_FIELDS.map((pf) => [pf.key, p[pf.key] || ""])),
  } : null;
  const clients = principalEntry ? [principalEntry, ...namedAssistiti] : [...namedAssistiti];
  const collegateOthers = (collegate || []).filter((x) => x.id !== p.id);

  const openAllegati = (c) => { setAllegatiClient(c || clients[0] || null); setAllegatiOpen(true); };
  const [urlParams, setUrlParams] = useSearchParams();
  const allegatiParam = urlParams.get("allegati");
  const [allegatiCat, setAllegatiCat] = useState(null);
  useEffect(() => {
    if (!allegatiParam) return;
    setAllegatiCat("assistito");
    openAllegati(clients.find((c) => clientKey(c) === allegatiParam) || clients[0]);
    setUrlParams({ p: p.id }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allegatiParam, p.id]);
  useEffect(() => {
    if (allegatiOpen) setTimeout(() => window.dispatchEvent(new Event(ATT_REFRESH_EVENT)), 1500);
  }, [allegatiOpen]);
  const openDiario = (c) => { setDiarioClient(c || clients[0] || null); setDiarioOpen(true); };
  const openWhatsApp = (c, n) => { setWaClient(c || clients[0] || null); setWaNum(n || ""); setWaOpen(true); };
  const openQuietanze = (index, c) => { setQuietanzeIndex(index); setQuietanzeClient(c || clients[0] || null); setQuietanzeOpen(true); };
  const saveClientConfig = async (patch) => {
    if (quietanzeIndex === "principal" || quietanzeIndex == null) {
      await persistClients([{ ...(clients[0] || {}), ...patch }, ...clients.slice(1)]);
    } else {
      const arr = [...assistiti]; arr[quietanzeIndex] = { ...(assistiti[quietanzeIndex] || {}), ...patch };
      await patchP({ assistiti: arr });
    }
    setQuietanzeClient((c) => ({ ...(c || {}), ...patch }));
  };
  const openLettere = (c) => { setLettereClient(c || clients[0] || null); setLettereOpen(true); };

  const stripEntry = (c) => { const { __principal, ...rest } = c || {}; return rest; };
  const toggleCondCliente = async (i, c, isPrincipal) => {
    const cond = (isPrincipal ? p.conducente : c.conducente) || {};
    const name = condPersonName(cond);
    const on = !!cond.come_cliente;
    const newCond = { ...cond, come_cliente: !on };
    if (on) {
      const old = clients.find((x) => x.da_conducente && (cond.cliente_id ? x.cliente_id === cond.cliente_id : x.nominativo_conducente === name));
      if (old) { newCond.pro_salvati = Object.fromEntries([...PRO_FIELDS, ...COND_PRO_FIELDS].map((pf) => [pf.key, old[pf.key] || ""])); }
    }
    let list = isPrincipal ? clients : clients.map((x, k) => (k === i ? { ...x, conducente: newCond } : x));
    if (on) {
      if (!window.confirm(`Disattivare ${name} come secondo cliente? Verrà tolto dalla lista clienti della pratica.`)) return;
      list = list.filter((x) => !(x.da_conducente && (cond.cliente_id ? x.cliente_id === cond.cliente_id : x.nominativo_conducente === name)));
    } else {
      const { is_cliente, come_cliente, pro_salvati, ...rest } = cond;
      list = [...list, { ...rest, ...(pro_salvati || {}), ragione_sociale: name, ruolo: "Conducente", da_conducente: true, nominativo_conducente: name }];
    }
    await persistClients(list);
    if (isPrincipal) { await patchP({ conducente: newCond }); }
    toast.success(on ? "Conducente tolto dai clienti" : `${name} aggiunto come secondo cliente`);
  };
  const persistClients = async (list) => {
    const first = list[0] || {};
    const rest = list.slice(1);
    const nameOf = (c) => c.ragione_sociale || [c.cognome, c.nome].filter(Boolean).join(" ").trim() || "";
    const firstComp = first.compagnia || first.assicurazione || "";
    const proTop = Object.fromEntries(PRO_FIELDS.map((pf) => [pf.key, first[pf.key] || ""]));
    const topUpdates = {
      cliente_id: first.cliente_id || null,
      nome_assistito: nameOf(first),
      assistito_ragione_sociale: nameOf(first),
      assistito_ruolo: first.ruolo || "",
      assistito_compagnia: firstComp,
      compagnia: firstComp,
      assistito_ispettorato: first.ispettorato || "",
      assistito_num_sinistro: first.num_sinistro || "",
      assistito_istruttore: first.istruttore || "",
      targa: first.targa || "",
      codice_fiscale: first.codice_fiscale || "",
      assistito_scheda: stripEntry(first),
      ...((first.segnalatore || "") !== ((p.assistito_scheda || {}).segnalatore || "") ? { segnalatore: first.segnalatore || "" } : {}),
      ...proTop,
    };
    const assistitiNew = [
      { assicurazione: firstComp, compagnia: firstComp, ispettorato: first.ispettorato || "", targa: first.targa || "" },
      ...rest.map((c) => ({ ...stripEntry(c), ragione_sociale: nameOf(c), cliente_id: c.cliente_id || null, ruolo: c.ruolo || "Assistito" })),
    ];
    await patchP({ ...topUpdates, assistiti: assistitiNew });
  };

  const toggleDefinita = (i, tipo) => {
    const list = clients.map((c, idx) => (idx === i ? (tipo ? { ...c, definita: true, definita_tipo: tipo } : { ...c, definita: false, definita_tipo: "" }) : c));
    persistClients(list);
  };

  const moveClient = async (index, dir) => {
    const j = index + dir;
    if (j < 0 || j >= clients.length) return;
    const list = [...clients];
    [list[index], list[j]] = [list[j], list[index]];
    try { await persistClients(list); toast.success("Ordine clienti aggiornato"); }
    catch (e) { /* patchP mostra già l'errore */ }
  };
  const [proCatalog, setProCatalog] = useState({});
  const [proDialog, setProDialog] = useState(null);
  const [proEdits, setProEdits] = useState({});
  const [sinistroOpen, setSinistroOpen] = useState(false);
  const [pecOpen, setPecOpen] = useState(false);
  const [pecInitAtt, setPecInitAtt] = useState([]);
  const [pecClient, setPecClient] = useState(null);
  const [emailOpen, setEmailOpen] = useState(false);
  const [emailInitAtt, setEmailInitAtt] = useState([]);
  const loadOneCatalog = async (atype) => { try { const { data } = await api.get(`/anagrafiche/${atype}`); setProCatalog((c) => ({ ...c, [atype]: data })); } catch {} };
  useEffect(() => { PRO_ATYPES.forEach(loadOneCatalog); /* eslint-disable-next-line */ }, []);
  const commitPro = (pf, v) => { saveField(pf.key, v); if (!v) return; const items = proCatalog[pf.atype] || []; if (!items.some((i) => displayName(i).toLowerCase() === v.toLowerCase())) setProDialog({ ...pf, initialName: v, editRec: null }); };
  const handleProDone = (saved, rec) => { const pd = proDialog; setProDialog(null); if (saved && rec && pd) { const nm = displayName(rec); setProEdits((e) => ({ ...e, [pd.key]: nm })); saveField(pd.key, nm); loadOneCatalog(pd.atype); } };

  const generaDoc = async (tipo) => {
    try {
      const { data } = await api.post(`/studio/pratiche/${p.id}/genera-documento`, { tipo });
      setDoc({ title: data.title, content: data.content });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const cancellaAssistito = () => {
    setDelTarget({ principal: true, name: assistitoLabel || "l'assistito principale" });
  };

  const saveControparte = async (data, index) => {
    const isFirst = index === 0 || (index == null && controparti.length === 0);
    const cond = data.conducente;
    if (isFirst) delete data.conducente;
    const arr = [...controparti];
    if (index == null) arr.push(data);
    else arr[index] = data;
    await patchP({ controparti: arr });
    if (isFirst && cond !== undefined) await patchP({ controparte_conducente: cond });
    setCpDialog(null);
    toast.success(index == null ? "Controparte aggiunta" : "Controparte aggiornata");
  };

  const saveCpField = (index, key, value) => {
    if ((controparti[index]?.[key] || "") === (value || "")) return;
    const arr = [...controparti];
    arr[index] = { ...arr[index], [key]: value };
    patchP({ controparti: arr }).then(() => toast.success("Campo salvato")).catch(() => {});
  };

  const saveCpNumber = (index, key, value) => {
    if ((Number(controparti[index]?.[key]) || 0) === (Number(value) || 0)) return;
    const arr = [...controparti];
    arr[index] = { ...arr[index], [key]: value };
    patchP({ controparti: arr }).then(() => toast.success("Campo salvato")).catch(() => {});
  };

  const setCpPrincipale = (index, checked) => {
    const arr = controparti.map((c, idx) => ({ ...c, responsabile_principale: checked ? idx === index : (idx === index ? false : c.responsabile_principale) }));
    patchP({ controparti: arr }).then(() => toast.success(checked ? "Responsabile principale impostato" : "Responsabile principale rimosso")).catch(() => {});
  };

  const respSum = controparti.reduce((s, c) => s + (Number(c.responsabilita_perc) || 0), 0);

  const delControparte = async (index) => {
    const name = controparti[index]?.ragione_sociale || "controparte";
    if (!window.confirm(`Cancellare "${name}" dalla pratica?`)) return;
    const arr = controparti.filter((_, i) => i !== index);
    await patchP({ controparti: arr });
    setCpOpen((o) => ({ ...o, [index]: false }));
    toast.success("Controparte rimossa");
  };

  const testimoni = Array.isArray(p.testimoni) ? p.testimoni : [];
  const testName = (t) => (t?.nominativo || [t?.cognome, t?.nome].filter(Boolean).join(" ")).trim() || "Testimone";

  const saveTestimone = async (data, index) => {
    const arr = [...testimoni];
    if (index == null) arr.push(data);
    else arr[index] = { ...arr[index], ...data };
    await patchP({ testimoni: arr });
    setTDialog(null);
    if (index == null) setTOpen((o) => ({ ...o, [arr.length - 1]: true }));
    toast.success(index == null ? "Testimone aggiunto" : "Testimone aggiornato");
  };

  const delTestimone = async (index) => {
    const name = testName(testimoni[index]);
    if (!window.confirm(`Cancellare "${name}" dalla pratica?`)) return;
    const arr = testimoni.filter((_, i) => i !== index);
    await patchP({ testimoni: arr });
    setTOpen((o) => ({ ...o, [index]: false }));
    toast.success("Testimone rimosso");
  };

  const tActions = (index) => [
    { icon: Trash2, label: "Cancella", on: () => delTestimone(index), danger: true },
    { icon: Pencil, label: "Modifica", on: () => setTDialog({ index, data: testimoni[index] }) },
  ];

  const CLI_CONTATTI = [{ key: "cell", label: "Cellulare" }, { key: "tel_casa", label: "Tel. casa" }, { key: "tel_ufficio", label: "Tel. ufficio" },
    { key: "fax", label: "Fax" }, { key: "email", label: "Email" }, { key: "pec", label: "PEC" }];
  const CP_CONTATTI = [{ key: "telefono", label: "Telefono" }, { key: "tel_ufficio", label: "Tel. ufficio" }, { key: "fax", label: "Fax" }, { key: "email", label: "Email" }, { key: "pec", label: "PEC" }];
  const cliVals = (c) => ({ ...c, cell: c.cell || c.cellulare || "", tel_casa: c.tel_casa || c.telefono || "" });
  const cpVals = (c) => ({ ...c, telefono: c.telefono || c.cellulare || "" });
  const ANAG_CONTATTO = { cell: "cellulare", tel_casa: "telefono", email: "email", pec: "pec" };
  const saveClientContact = async (c, rawIdx, key, value) => {
    try {
      if (c.__principal) {
        const { __principal, ...rest } = c;
        await persistClients([{ ...rest, [key]: value }, ...clients.slice(1)]);
      } else {
        const arr = [...assistiti];
        arr[rawIdx] = { ...arr[rawIdx], [key]: value };
        await patchP({ assistiti: arr });
      }
      if (c.cliente_id && ANAG_CONTATTO[key]) await api.patch(`/anagrafiche/clienti/${c.cliente_id}`, { [ANAG_CONTATTO[key]]: value }).catch(() => {});
      toast.success("Contatto aggiornato");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const saveAssistito = async (data, index) => {
    data.ragione_sociale = [data.cognome, data.nome].filter(Boolean).join(" ").trim() || data.ragione_sociale || "";
    // aggiorna/crea la scheda in Anagrafica Clienti con i dati inseriti
    try {
      const iso = (g, m, a) => (g && m && a) ? `${String(a).padStart(4, "0")}-${String(m).padStart(2, "0")}-${String(g).padStart(2, "0")}` : "";
      const payload = {
        titolo: data.titolo || "", nome: data.nome || "", cognome: data.cognome || "", sesso: data.sesso || "",
        codice_fiscale: data.codice_fiscale || "", partita_iva: data.partita_iva || (data.soggetto_iva === "SI" ? (data.codice_fiscale || "") : ""),
        soggetto_iva: data.soggetto_iva || "NO", tel_ufficio: data.tel_ufficio || "",
        ...Object.fromEntries(Object.entries(data).filter(([k]) => k.startsWith("rappr_"))),
        data_nascita: iso(data.nasc_g, data.nasc_m, data.nasc_a),
        luogo_nascita: data.comune_nascita || "", provincia_nascita: data.comune_nascita_prov || "",
        professione: data.professione || "",
        indirizzo: data.indirizzo || "", comune: data.comune || "", cap: data.cap || "", provincia: data.provincia || "",
        telefono: data.tel_casa || "", cellulare: data.cell || "", email: data.email || "", pec: data.pec || "",
        ...(data.cell_principale != null ? { cellulari_extra: data.cellulari_extra || [], cell_principale: data.cell_principale || 0 } : {}),
        ...(Array.isArray(data.cellulari_etichette) ? { cellulari_etichette: data.cellulari_etichette } : {}),
        iban: data.iban || "", codice_destinatario: data.codice_destinatario || "",
      };
      let cid = data.cliente_id;
      if (!cid) {
        const q = data.codice_fiscale || data.ragione_sociale;
        if (q) {
          const { data: list } = await api.get(`/anagrafiche/clienti?q=${encodeURIComponent(q)}`);
          const m = (list || []).find((r) =>
            (r.codice_fiscale && data.codice_fiscale && r.codice_fiscale.toUpperCase() === data.codice_fiscale.toUpperCase()) ||
            (`${r.nome || ""} ${r.cognome || ""}`.trim().toLowerCase() === `${data.nome || ""} ${data.cognome || ""}`.trim().toLowerCase()));
          if (m) cid = m.id;
        }
      }
      if (cid) { await api.patch(`/anagrafiche/clienti/${cid}`, payload); }
      else { const { record } = await guardCreate("clienti", payload); cid = record.id; }
      if (cid) data.cliente_id = cid;
    } catch (e) { /* sync non bloccante */ }
    if (index === "principal" || (index == null && !principalEntry)) {
      const cond = data.conducente; delete data.conducente;
      await persistClients(index == null ? [data, ...clients] : [data, ...clients.slice(1)]);
      if (cond !== undefined) await patchP({ conducente: cond });
      setADialog(null);
      setAssistitoOpen(true);
      toast.success(index == null ? "Assistito aggiunto" : "Assistito aggiornato");
      return;
    }
    const arr = [...assistiti];
    let openIdx;
    if (index == null) { arr.push(data); openIdx = arr.length - 1; }
    else { arr[index] = data; openIdx = index; }
    await patchP({ assistiti: arr });
    setADialog(null);
    setAOpen((o) => ({ ...o, [openIdx]: true }));
    toast.success(index == null ? "Assistito aggiunto" : "Assistito aggiornato");
  };

  const delAssistito = (index) => {
    const a = assistiti[index] || {};
    const name = (a.ragione_sociale || [a.cognome, a.nome].filter(Boolean).join(" ")).trim() || "questo assistito";
    setDelTarget({ index, name });
  };

  const confirmDelAssistito = async () => {
    if (!delTarget) return;
    setDeleting(true);
    try {
      if (delTarget.principal) {
        const { data } = await api.delete(`/studio/pratiche/${p.id}/assistito-principale`);
        const merged = data.pratica ? { ...p, ...data.pratica } : { ...p };
        setP(merged);
        onSaved && onSaved(merged);
        setAssistitoOpen(false);
      } else {
        const { data } = await api.delete(`/studio/pratiche/${p.id}/assistiti/${delTarget.index}`);
        const merged = { ...p, assistiti: Array.isArray(data.assistiti) ? data.assistiti : [] };
        setP(merged);
        onSaved && onSaved(merged);
        setAOpen((o) => ({ ...o, [delTarget.index]: false }));
      }
      toast.success(`${delTarget.name} eliminato definitivamente`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setDeleting(false);
      setDelTarget(null);
    }
  };

  const subjActions = [
    { icon: Trash2, label: "Cancella", on: cancellaAssistito, danger: true },
    { icon: Pencil, label: "Modifica", on: () => setADialog({ index: "principal", data: principalEntry || {} }) },
    { icon: BookText, label: "Diario", on: () => openDiario(principalEntry) },
    { icon: MessageSquare, label: "Messaggi", on: () => setMessaggiOpen(true) },
    { icon: Mails, label: "Comunicazioni", labelLines: ["Comunic.", "Email"], badge: comUnread, on: () => setComunicazioniOpen(true) },
    { icon: MessageCircle, label: "SMS", on: () => soon(`SMS · ${assistitoLabel}`) },
    { icon: Calculator, label: "Quantifica", on: () => setQuantOpen(true) },
    { icon: Hammer, label: "Ricostruisci", on: () => soon(`Ricostruisci · ${assistitoLabel}`) },
    { icon: UserSearch, label: "Periziatore", on: () => soon(`Periziatore · ${assistitoLabel}`) },
    { icon: FileBarChart, label: "PML", on: () => soon(`PML · ${assistitoLabel}`) },
    { icon: BadgeEuro, label: "Offerta", on: () => setOffertaOpen(true) },
    { icon: ReceiptText, label: "Quietanza", on: () => openQuietanze("principal", principalEntry) },
    { icon: MailCheck, label: "PEC", on: () => { setPecClient(principalEntry); setPecOpen(true); } },
    { icon: Mail, label: "Email", on: () => { setEmailInitAtt([]); setEmailOpen(true); } },
    { icon: FileText, label: "Lettere", on: () => openLettere(clients[0]) },
    { icon: Paperclip, label: "Allegati", on: () => openAllegati(clients[0]) },
    { icon: Globe, label: "Web", on: () => setWebOpen(true) },
    { icon: AlertTriangle, label: "Reclamo", on: () => soon(`Reclamo · ${assistitoLabel}`) },
    { icon: ShieldAlert, label: "Anti frode", on: () => soon(`Anti frode · ${assistitoLabel}`) },
    { icon: Coins, label: "Costi", on: () => setCostiOpen(true) },
    { icon: Receipt, label: "Fattura", on: () => setFatturaOpen(true) },
    { icon: FileText, label: "Proforma", on: () => { const c = principalEntry || clients[0]; setProformaClient(buildProformaClient(c)); setProformaClientKey(clientKey(c)); setProformaListOpen(true); } },
  ];

  const assistitoActions = (index, a) => subjActions.map((act) =>
    act.label === "Cancella" ? { ...act, on: () => delAssistito(index) }
      : act.label === "Modifica" ? { ...act, on: () => setADialog({ index, data: a }) }
        : act.label === "PEC" ? { ...act, on: () => { setPecClient(a); setPecOpen(true); } }
        : act.label === "Diario" ? { ...act, on: () => openDiario(a) }
        : act.label === "Allegati" ? { ...act, on: () => openAllegati(a) }
          : act.label === "Lettere" ? { ...act, on: () => openLettere(a) }
            : act.label === "Quietanza" ? { ...act, on: () => openQuietanze(index, a) }
            : act.label === "Proforma" ? { ...act, on: () => { setProformaClient(buildProformaClient(a)); setProformaClientKey(clientKey(a)); setProformaListOpen(true); } }
            : act
  );

  const buildProformaClient = (a) => {
    const cognome = (a?.cognome || "").trim();
    const nome = (a?.nome || "").trim();
    const rs = (a?.ragione_sociale || "").trim();
    const isAzienda = !cognome && !nome && !!rs;
    const nm = (isAzienda ? rs : [cognome, nome].filter(Boolean).join(" ").trim()) || p.nome_assistito || p.cliente_nome || "";
    return {
      intestatario: nm,
      cliente_dati: {
        tipo: isAzienda ? "azienda" : "persona",
        nome,
        cognome,
        ragione_sociale: isAzienda ? rs : "",
        indirizzo: a?.indirizzo || "",
        numero_civico: a?.numero_civico || "",
        cap: a?.cap || "",
        citta: a?.comune || a?.citta || "",
        provincia: a?.provincia || "",
        codice_fiscale: a?.codice_fiscale || a?.cod_fisc || "",
        partita_iva: a?.partita_iva || "",
        email: a?.email || "",
        pec: a?.pec || "",
      },
    };
  };

  const cpActions = (index) => [
    { icon: Trash2, label: "Cancella", on: () => delControparte(index), danger: true },
    { icon: Pencil, label: "Modifica", on: () => setCpDialog({ index, data: controparti[index] }) },
  ];

  const left = [
    ["N° Pratica", V(p.numero_pratica), true],
    ["Tipo", V(p.tipo)],
    ["Utente", V(user?.demo_registered ? (user.name || user.email) : (p.utente || p.cliente_nome))],
    ["Pratica Connessa", V(p.pratica_connessa)],
    ["Segnalatore", V(p.segnalatore)],
    ...(tFlags.veicolo ? [["Veicoli Coinvolti", V(p.veicoli_coinvolti)]] : []),
  ];
  const right = [
    ["Data Sinistro", formatDate(p.data_sinistro), true],
    ["Orario Sinistro", V(p.ora_sinistro)],
    ["Località Sinistro", V(p.luogo_sinistro)],
    ["Indirizzo Sinistro", V(p.indirizzo_sinistro)],
    ["Autorità Intervenute", V(autoritaFull(p))],
    ["Stato Aggiuntivo", V(p.stato_aggiuntivo)],
    ["Stato", STATO[p.stato] || p.stato],
    ["Responso D.P.R.", V(p.responso_dpr)],
  ];

  const riapriPratica = async () => {
    if (!window.confirm("Riaprire questa pratica? Tornerà modificabile.")) return;
    try {
      await patchP({ stato: "aperta" }, { force: true });
      toast.success("Pratica riaperta");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Riapertura non riuscita"); }
  };

  return (
    <div data-testid="pratica-detail" className="pgp-fade-up">
      {chiusa && (
        <div data-testid="pratica-chiusa-banner" className="mb-4 flex items-center justify-between gap-4 rounded-lg border border-amber-500/50 bg-amber-500/10 px-4 py-3">
          <div className="flex items-center gap-3 min-w-0">
            <Lock className="h-5 w-5 text-amber-400 shrink-0" />
            <div className="min-w-0">
              <div className="text-sm font-semibold text-amber-300">Pratica chiusa — sola lettura</div>
              <div className="text-xs text-amber-200/80 pgp-chiusa-sub">Questa pratica non è modificabile. {isAdmin ? "Puoi riaprirla per apportare modifiche." : "Contatta un amministratore per riaprirla."}</div>
            </div>
          </div>
          {isAdmin && (
            <button type="button" onClick={riapriPratica} data-testid="riapri-pratica-btn"
              className="flex items-center gap-2 text-sm rounded-md border border-amber-500/50 bg-amber-500/15 text-amber-200 hover:bg-amber-500/25 px-3 py-1.5 shrink-0 transition-colors">
              <Unlock className="h-4 w-4" /> Riapri pratica
            </button>
          )}
        </div>
      )}
      <div className="flex items-center justify-between mb-5">
        <ProfessionistiDialog open={webOpen} onOpenChange={setWebOpen} pratica={p} />
        <button onClick={onBack} data-testid="pratica-back" className="flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors">
          <ArrowLeft className="h-4 w-4" /> {backLabel || "Torna alle pratiche"}
        </button>
        <div className="flex flex-wrap items-center justify-end gap-2">
          <button type="button" data-testid="testimoni-btn" onClick={() => setTestimoniOpen(true)}
            className="flex items-center gap-2 text-sm rounded-md border border-sky-500/40 text-sky-300 hover:bg-sky-500/10 px-3 py-1.5 transition-colors whitespace-nowrap">
            <Users className="h-4 w-4" /> Testimoni
            <span data-testid="testimoni-count" className="inline-flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full bg-sky-500/20 text-sky-200 text-[11px] font-bold">{testimoni.length}</span>
          </button>
          <button type="button" data-testid="add-appuntamento-pratica-btn" onClick={() => setAppuntamentoOpen(true)}
            className="flex items-center gap-2 text-sm rounded-md border border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 px-3 py-1.5 transition-colors whitespace-nowrap">
            <CalendarPlus className="h-4 w-4" /> Nuovo Promemoria
          </button>
          <button type="button" data-testid="genera-cai-cid"
            onClick={async () => { let studio = {}; try { const { data } = await api.get("/studio/me"); studio = { name: data.studio_name, ...(data.settings || {}) }; } catch (e) { /* studio opzionale */ } const fresh = praticaToCaiForm(p); let caiForm = fresh; if (p.cai_cid_form && typeof p.cai_cid_form === "object") { caiForm = { ...p.cai_cid_form, A: { ...(p.cai_cid_form.A || {}) }, B: { ...(p.cai_cid_form.B || {}) } }; for (const side of ["A", "B"]) { for (const f of ["patente", "categoria", "patente_scad"]) { if (!caiForm[side][f] && fresh[side] && fresh[side][f]) caiForm[side][f] = fresh[side][f]; } const f2 = caiForm[side].foglio2; if (!f2) caiForm[side].foglio2 = fresh[side].foglio2; else if (!(f2.feriti && f2.feriti[0] && f2.feriti[0].nome) && fresh[side].foglio2.feriti[0].nome) caiForm[side].foglio2 = { ...f2, feriti: [fresh[side].foglio2.feriti[0], (f2.feriti || [])[1] || fresh[side].foglio2.feriti[1]] }; } if (caiForm.sinistro && !caiForm.sinistro.feriti && fresh.sinistro.feriti) caiForm.sinistro = { ...caiForm.sinistro, feriti: fresh.sinistro.feriti }; } const telFlags = { A: !!((p.assistito_scheda || {}).tel_no_cai), B: !!(((p.controparti && p.controparti[0]) || {}).tel_no_cai) }; for (const side of ["A", "B"]) { if (telFlags[side] && caiForm[side]) { caiForm[side].cond_tel = ""; caiForm[side].tel = ""; } } setCaiChoose({ form: caiForm, studio }); }}
            className="flex items-center gap-2 text-sm rounded-md border border-blue-500/40 text-blue-400 hover:bg-blue-500/10 px-3 py-1.5 transition-colors">
            <FileText className="h-4 w-4" /> Genera CAI/CID
          </button>
          <button type="button" data-testid="stampa-copertina"
            onClick={() => setCopPec({ d: "", m: "", y: "" })}
            className="flex items-center gap-2 text-sm rounded-md border border-amber-500/40 text-amber-400 hover:bg-amber-500/10 px-3 py-1.5 transition-colors">
            <FileDown className="h-4 w-4" /> Stampa Copertina
          </button>
          <button type="button" data-testid="duplica-pratica-btn" onClick={() => setDuplicaOpen(true)}
            className="flex items-center gap-2 text-sm rounded-md border border-teal-500/40 text-teal-300 hover:bg-teal-500/10 px-3 py-1.5 transition-colors">
            <Copy className="h-4 w-4" /> Duplica Pratica
          </button>
          <button type="button" data-testid="share-allegati-btn" onClick={() => setShareOpen(true)}
            className="flex items-center gap-2 text-sm rounded-md border border-sky-500/40 text-sky-300 hover:bg-sky-500/10 px-3 py-1.5 transition-colors whitespace-nowrap">
            <Share2 className="h-4 w-4" /> Condividi allegati
          </button>
          <ShareCreateDialog open={shareOpen} onOpenChange={setShareOpen} praticaId={p.id} />
          <div className="relative">
            <button type="button" data-testid="pratiche-collegate-btn"
              onClick={() => setCollegateOpen((o) => !o)}
              className="flex items-center gap-2 text-sm rounded-md border border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 px-3 py-1.5 transition-colors whitespace-nowrap">
              <Link2 className="h-4 w-4" /> {collegateOthers.length > 0 ? "Pratiche collegate" : "Collega pratica"}
              {collegateOthers.length > 0 && (
                <span data-testid="collegate-count" className="inline-flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full bg-indigo-500/20 text-indigo-200 text-[11px] font-bold">{collegateOthers.length}</span>
              )}
            </button>
            {collegateOpen && (
              <div className="absolute right-0 mt-1 z-50 w-72 rounded-md border border-slate-700 bg-[#121824] shadow-xl p-1" data-testid="collegate-list">
                {collegateOthers.map((pr) => (
                  <button key={pr.id} type="button" onClick={() => openCollegata(pr)} data-testid="collegate-item"
                    className="w-full text-left px-2 py-1.5 rounded hover:bg-slate-800/70 flex items-center justify-between gap-2">
                    <span className="font-mono text-amber-400 text-xs">{pr.numero_pratica || "—"}</span>
                    <span className="text-[10px] text-slate-400">{pr.data_apertura ? formatDate(pr.data_apertura) : "—"} · {STATO[pr.stato] || pr.stato}</span>
                  </button>
                ))}
                <div className="border-t border-slate-800 mt-1 pt-1.5 px-1.5 pb-1">
                  <CollegaPraticaField currentId={p.id} currentNumero={p.numero_pratica} onSelect={collegaByTarget} />
                </div>
                {collegate.length > 0 && (
                  <div className="border-t border-slate-800 mt-1 pt-1">
                    <button type="button" onClick={scollegaPratica} data-testid="scollega-pratica-btn"
                      className="w-full text-left px-2 py-1.5 rounded text-xs text-red-400 hover:bg-red-500/10 flex items-center gap-2">
                      <Link2 className="h-3.5 w-3.5" /> Scollega questa pratica dal gruppo
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          {p.stato === "chiusa" && (
            <button type="button" data-testid="archivia-pratica-btn"
              onClick={async () => { if (!window.confirm("Archiviare questa pratica? Verrà spostata nell'Archivio Pratiche e non apparirà più nella lista principale.")) return; try { await api.post(`/studio/pratiche/${p.id}/archivia`); window.dispatchEvent(new Event("pgp-archivio-changed")); toast.success("Pratica archiviata"); onArchived && onArchived(p); } catch (e) { toast.error(e.response?.data?.detail || "Archiviazione non riuscita"); } }}
              className="flex items-center gap-2 text-sm rounded-md border border-purple-500/40 text-purple-300 hover:bg-purple-500/10 px-3 py-1.5 transition-colors">
              <Archive className="h-4 w-4" /> Archivia pratica
            </button>
          )}
        </div>
        {duplicaOpen && <DuplicaPraticaDialog pratica={p} clienti={clients} controparti={controparti} onClose={() => setDuplicaOpen(false)} onDuplicated={(data) => onDuplicated && onDuplicated(data)} />}
        <AppuntamentoDialog open={appuntamentoOpen} onOpenChange={setAppuntamentoOpen}
          initial={{ pratica_id: p.id, numero_pratica: p.numero_pratica }} onSaved={() => {}} />
        {copPreview && <PdfPreviewModal doc={copPreview.doc} filename={copPreview.filename} title="Anteprima Copertina" onClose={() => setCopPreview(null)} />}
        {copPec && (
          <Dialog open onOpenChange={(o) => { if (!o) setCopPec(null); }}>
            <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-sm" data-testid="cop-pec-dialog">
              <DialogHeader><DialogTitle className="font-head">Data PEC copertina</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div>
                  <Label className="text-slate-300 text-xs">Modello copertina</Label>
                  <select value={copModelSel} onChange={(e) => setCopModelSel(e.target.value)} data-testid="cop-model-choose"
                    className="mt-1 h-9 w-full rounded border border-slate-700 bg-slate-900/60 text-sm text-slate-100 px-2">
                    <option value="__default__" className="bg-slate-900 text-slate-100">Predefinito</option>
                    {copModelsList.map((m) => <option key={m.id} value={m.id} className="bg-slate-900 text-slate-100">{m.nome}</option>)}
                  </select>
                </div>
                <p className="text-sm text-slate-400">Compila la data della PEC che comparirà sopra il riquadro "PRATICA N." (lascia vuoto per stampare i trattini).</p>
                <div className="flex items-end gap-2">
                  <div className="w-16"><Label className="text-slate-300 text-xs">Giorno</Label><Input value={copPec.d} onChange={(e) => setCopPec((s) => ({ ...s, d: e.target.value.replace(/\D/g, "").slice(0, 2) }))} data-testid="cop-pec-d" placeholder="GG" className="mt-1 h-9 bg-slate-900/60 border-slate-700 text-center font-mono" /></div>
                  <span className="pb-2 text-slate-500">/</span>
                  <div className="w-16"><Label className="text-slate-300 text-xs">Mese</Label><Input value={copPec.m} onChange={(e) => setCopPec((s) => ({ ...s, m: e.target.value.replace(/\D/g, "").slice(0, 2) }))} data-testid="cop-pec-m" placeholder="MM" className="mt-1 h-9 bg-slate-900/60 border-slate-700 text-center font-mono" /></div>
                  <span className="pb-2 text-slate-500">/</span>
                  <div className="w-24"><Label className="text-slate-300 text-xs">Anno</Label><Input value={copPec.y} onChange={(e) => setCopPec((s) => ({ ...s, y: e.target.value.replace(/\D/g, "").slice(0, 4) }))} data-testid="cop-pec-y" placeholder="AAAA" className="mt-1 h-9 bg-slate-900/60 border-slate-700 text-center font-mono" /></div>
                </div>
              </div>
              <DialogFooter className="gap-2">
                <Button variant="outline" onClick={() => generaCopertina(null)} disabled={copGen} data-testid="cop-pec-skip" className="border-slate-700 text-slate-200 hover:bg-slate-800">Senza data</Button>
                <Button onClick={() => generaCopertina(copPec)} disabled={copGen} data-testid="cop-pec-confirm" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">{copGen ? <Loader2 className="h-4 w-4 animate-spin" /> : "Genera copertina"}</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}
        {caiPreview && <PdfPreviewModal doc={caiPreview.doc} filename={caiPreview.filename} title="Anteprima CAI/CID" onClose={() => setCaiPreview(null)} />}
        {caiChoose && <CaiCidOptionsDialog onClose={() => setCaiChoose(null)}
          onSelect={(modello, intestazione) => { setCaiEdit({ ...caiChoose, modello, intestazione }); setCaiChoose(null); }} />}
        {caiEdit && <CaiCidEditModal initialForm={caiEdit.form} onClose={() => setCaiEdit(null)}
          onReloadFromPratica={p.cai_cid_form ? () => {
            const fresh = praticaToCaiForm(p);
            const caiForm = { ...fresh, A: { ...(fresh.A || {}) }, B: { ...(fresh.B || {}) } };
            const telFlags = { A: !!((p.assistito_scheda || {}).tel_no_cai), B: !!(((p.controparti && p.controparti[0]) || {}).tel_no_cai) };
            for (const side of ["A", "B"]) { if (telFlags[side] && caiForm[side]) { caiForm[side].cond_tel = ""; caiForm[side].tel = ""; } }
            return caiForm;
          } : undefined}
          onSaveDraft={async (form) => {
            try { await patchP({ cai_cid_form: form }); setCaiEdit((c) => c ? { ...c, form } : c); toast.success("Bozza CAI/CID salvata nella pratica"); }
            catch (e) { toast.error("Salvataggio bozza non riuscito"); }
          }}
          onSaveAllegato={async ({ form }) => {
            try {
              await patchP({ cai_cid_form: form });
              const build = caiEdit.modello === "compatto" ? buildCaiCid : buildCaiCidUfficiale;
              const { doc: cdoc, filename } = build(form, caiEdit.studio, { intestazione: caiEdit.intestazione });
              const blob = cdoc.output("blob");
              const fd = new FormData();
              fd.append("file", new File([blob], filename, { type: "application/pdf" }));
              fd.append("categoria", "uscita");
              fd.append("assistito", clientKey(clients[0]));
              await api.post(`/studio/pratiche/${p.id}/allegati-files`, fd, { headers: { "Content-Type": "multipart/form-data" } });
              toast.success("Modulo CAI/CID allegato alla pratica (Documenti in uscita)");
            } catch (e) { toast.error("Salvataggio allegato non riuscito"); }
          }}
          onGenera={({ form }) => {
            try {
              const build = caiEdit.modello === "compatto" ? buildCaiCid : buildCaiCidUfficiale;
              const { doc: cdoc, filename } = build(form, caiEdit.studio, { intestazione: caiEdit.intestazione });
              setCaiEdit((c) => c ? { ...c, form } : c);
              setCaiPreview({ doc: cdoc, filename });
            } catch (e) { toast.error("Errore nella generazione del modulo CAI/CID"); }
          }} />}
      </div>

      {/* Header dati principali */}
      <div className="pgp-card pgp-sec pgp-sec-dati p-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 font-mono mb-2">Dati Pratica</div>
        <div className="flex items-center justify-between mb-4">
          <h1 className="font-head text-2xl font-extrabold text-slate-50">
            {p.numero_pratica}{hasPrincipal && p.nome_assistito ? <> <span className="text-slate-500">·</span> {p.nome_assistito}</> : null}
          </h1>
          <Badge className={`border ${STATO_STYLE[p.stato] || STATO_STYLE.aperta}`}>{STATO[p.stato] || p.stato}</Badge>
        </div>
        {offertaAccettata && (
          <div className="mb-4 -mt-2">
            <Badge data-testid="badge-offerta-accettata" className="border border-emerald-500/40 bg-emerald-500/15 text-emerald-300">Offerta accettata</Badge>
          </div>
        )}
        <div className="grid md:grid-cols-2 gap-4">
          <div className="rounded-md border border-slate-300 overflow-hidden">
            {left.map(([k, v, m], idx) => k === "Pratica Connessa" ? (
              <Field key={k} label={k} alt={idx % 2 === 1} mono testId="field-pratica-connessa">
                {collegateOthers.length > 0 ? (
                  <span className="flex flex-wrap items-center gap-x-2 gap-y-1" data-testid="pratica-connessa-list">
                    {collegateOthers.map((pr, ci) => (
                      <span key={pr.id} className="inline-flex items-center gap-2">
                        <button type="button" onClick={() => openCollegata(pr)} data-testid={`open-pratica-connessa-${pr.id}`}
                          title={`${pr.nome_assistito || "Assistito n.d."}${pr.data_sinistro ? ` — Sinistro del ${formatDate(pr.data_sinistro)}` : ""}`}
                          className="text-blue-700 hover:text-blue-900 underline underline-offset-2 font-mono">{pr.numero_pratica || "—"}</button>
                        {ci < collegateOthers.length - 1 && <span className="text-slate-400">·</span>}
                      </span>
                    ))}
                  </span>
                ) : (
                  <span className="text-slate-500" data-testid="pratica-connessa-none">Nessuna connessione</span>
                )}
              </Field>
            ) : <Field key={k} label={k} value={v} mono={m} alt={idx % 2 === 1} />)}
          </div>
          <div className="rounded-md border border-slate-300 overflow-hidden">
            {right.map(([k, v, m], idx) => k === "Stato Aggiuntivo" ? (
              <AField key={k} label={k} alt={idx % 2 === 1}>
                <StatoAggiuntivoField value={p.stato_aggiuntivo || ""} onCommit={(val) => { if ((val || "") !== (p.stato_aggiuntivo || "")) saveField("stato_aggiuntivo", val); }} testId="pa-stato-aggiuntivo" />
              </AField>
            ) : k === "Stato" ? (
              <AField key={k} label={k} alt={idx % 2 === 1}>
                <select value={p.stato || "aperta"} disabled={chiusa} onChange={(e) => { if (e.target.value !== p.stato) saveField("stato", e.target.value); }} data-testid="pa-stato-select"
                  className={`h-9 w-full rounded-md bg-slate-900/60 border border-slate-700 text-slate-100 text-sm px-2 focus:outline-none focus:ring-1 focus:ring-amber-500/40 ${chiusa ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}>
                  {STATO_OPZIONI.map((o) => <option key={o.v} value={o.v} className="bg-[#121824]">{o.l}</option>)}
                  {p.stato && !STATO_OPZIONI.some((o) => o.v === p.stato) && <option value={p.stato} className="bg-[#121824]">{STATO[p.stato] || p.stato}</option>}
                </select>
              </AField>
            ) : <Field key={k} label={k} value={v} mono={m} alt={idx % 2 === 1} />)}
          </div>
        </div>
        {(principalEntry?.segnalatore || "").trim() && (
          <div className="mt-3 text-[11px] text-slate-400" data-testid="posizione-inclusa-segnalatore">
            <span className="uppercase tracking-wider font-mono">Posizione inclusa al segnalatore <span className="text-amber-400">{principalEntry.segnalatore}</span></span>
            <SegnalatoreAnagWarning nome={principalEntry.segnalatore} />
          </div>
        )}
      </div>

      {/* Descrizione sinistro */}
      <div className="pgp-card pgp-sec pgp-sec-dati p-6 mt-4">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-mono">Descrizione Sinistro</div>
          <button type="button" onClick={() => setSinistroOpen(true)} data-testid="modifica-dati-sinistro" className="text-xs font-semibold rounded-md border border-amber-500/40 text-amber-400 hover:bg-amber-500/10 px-2.5 py-1.5 transition-colors">Modifica dati sinistro</button>
        </div>
        <p className="text-sm text-slate-200 whitespace-pre-wrap leading-relaxed">{V(p.descrizione_sinistro || p.note)}</p>
      </div>

      {/* Assistito / Controparti */}
      <PraticaWaTextContext.Provider value={waCtx}>
      <div className="grid lg:grid-cols-2 gap-4 mt-4">
        {/* ASSISTITO */}
        <div className="pgp-card pgp-sec pgp-sec-assistito overflow-hidden" data-testid="panel-assistito">
          <div className="px-5 py-3 border-b pgp-sec-assistito-head flex items-center justify-between">
            <span className="text-sm font-head font-bold text-teal-300 tracking-wide flex items-center gap-2 min-w-0">ASSISTITO<CompagniaHead compagnia={compagniaAssistito} gest={isRD} testId="assistito-head-compagnia" /></span>
            <button onClick={() => setADialog({ index: null, data: null })} data-testid="add-assistito-btn"
              className="flex items-center gap-1 text-xs text-teal-300 hover:text-teal-200 border border-teal-500/30 rounded-md px-2 py-1 transition-colors">
              <Plus className="h-3.5 w-3.5" /> Aggiungi
            </button>
          </div>
          <table className="w-full text-sm border-b border-slate-800">
            <thead>
              <tr className="text-left text-slate-500 text-[10px] uppercase tracking-wider font-mono border-b border-slate-800">
                <th className="px-4 py-2 w-8">#</th>
                <th className="px-5 py-2">Ragione Sociale</th>
                <th className="px-5 py-2">Ruolo</th>
                <th className="px-3 py-2 w-16 text-center">Ordine</th>
              </tr>
            </thead>
            <tbody>
              {clients.length === 0 && (
                <tr data-testid="assistito-empty">
                  <td colSpan={4} className="px-5 py-6 text-center text-sm text-slate-500">Nessun assistito. Usa "Aggiungi" per inserirne uno.</td>
                </tr>
              )}
              {clients.map((c, i) => {
                const isPrincipal = i === 0;
                const rawIdx = c.__principal ? -1 : assistiti.indexOf(c);
                const open = c.__principal ? assistitoOpen : aOpen[i];
                const toggle = () => c.__principal ? setAssistitoOpen((o) => !o) : setAOpen((o) => ({ ...o, [i]: !o[i] }));
                const items = (c.__principal ? subjActions : assistitoActions(rawIdx, c)).filter((act) => !offMods.has(`pratica:${act.label}`));
                return (
                  <Fragment key={i}>
                    <tr onClick={toggle} data-testid={`cliente-row-${i}`}
                      className={`group/clirow cursor-pointer transition-colors ${open ? "bg-teal-500/10" : `${i % 2 === 1 ? "bg-slate-500/10 " : ""}hover:bg-slate-800/40`}`}>
                      <td className="px-4 py-2.5 text-slate-500 font-mono">{i + 1}</td>
                      <td className="px-5 py-2.5 text-slate-100 font-medium">
                        {(() => {
                          const fisso = (c.tel_casa || "").trim();
                          const cell = (c.cell || "").trim();
                          const nameEl = <span className="uppercase">{V(c.ragione_sociale)}</span>;
                          if (!fisso && !cell) return nameEl;
                          return (
                            <TooltipProvider delayDuration={200}>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <span className="uppercase cursor-help underline decoration-dotted decoration-slate-500 underline-offset-2" data-testid={`cliente-nome-${i}`}>{V(c.ragione_sociale)}</span>
                                </TooltipTrigger>
                                <TooltipContent side="top" align="start" className="bg-popover text-popover-foreground border border-border shadow-xl" data-testid={`cliente-tel-tooltip-${i}`}>
                                  <div className="space-y-1">
                                    {cell && <div className="group/num flex items-center gap-1.5" data-testid={`cliente-tel-cell-${i}`}><Smartphone className="h-3.5 w-3.5 text-amber-500" /><span className="font-mono">{cell}</span><CopyBtn value={cell} testId={`cliente-tel-cell-copy-${i}`} /></div>}
                                    {fisso && <div className="group/num flex items-center gap-1.5" data-testid={`cliente-tel-fisso-${i}`}><Phone className="h-3.5 w-3.5 text-amber-500" /><span className="font-mono">{fisso}</span><CopyBtn value={fisso} testId={`cliente-tel-fisso-copy-${i}`} /></div>}
                                  </div>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          );
                        })()}
                        {(() => {
                          const nums = cellOptions(cliVals(c), "cell");
                          const btn = (n, j) => (
                            <button type="button" onClick={(e) => { e.stopPropagation(); openWhatsApp(c, n); }} data-testid={j ? `cliente-whatsapp-${i}-${j}` : `cliente-whatsapp-${i}`} title={n ? `WhatsApp ${n}` : "Invia messaggio WhatsApp"}
                              className="inline-flex items-center justify-center h-6 w-6 rounded-md align-middle text-[#25D366] hover:bg-[#25D366]/15 transition-colors">
                              <WaGlyph className="h-4 w-4" />
                            </button>
                          );
                          if (nums.length < 2 && !nums[0]?.label) return <span className="ml-2 inline-flex align-middle">{btn(nums[0]?.n || "", 0)}</span>;
                          return nums.map((o, j) => (
                            <span key={o.n} className="ml-2 inline-flex items-center gap-0.5 align-middle text-[11px] text-slate-400" data-testid={`cliente-num-${i}-${j}`}>
                              <span className="font-mono">{o.n}</span>{o.label && <span className="rounded bg-slate-700/40 px-1 py-px text-[10px] normal-case">{o.label}</span>}{btn(o.n, j)}
                            </span>
                          ));
                        })()}
                        <AreaStatusBadge status={areaFor(c)} testId={`cliente-area-${i}`} />
                        <SoggettoBell pratiche={subjMatches(c)} onOpen={openCollegata} testId={`cliente-bell-${i}`} />
                        {isPrincipal && <span data-testid={`cliente-principale-badge-${i}`} className="ml-2 inline-block text-[9px] font-bold uppercase tracking-wider text-teal-950 bg-teal-400 rounded px-1.5 py-0.5 align-middle">Principale</span>}
                        {c.da_conducente && <span data-testid={`cliente-conducente-badge-${i}`} title="Conducente attivato come secondo cliente" className="ml-2 inline-block text-[9px] font-bold uppercase tracking-wider text-teal-950 bg-teal-300 rounded px-1.5 py-0.5 align-middle">Conducente</span>}
                        {isMinore(c) && <span data-testid={`cliente-minore-badge-${i}`} title={`Cliente minore (${etaAnni(c)} anni): esercenti potestà nella scheda cliente`} className="ml-2 inline-block text-[9px] font-bold uppercase tracking-wider text-amber-950 bg-amber-400 rounded px-1.5 py-0.5 align-middle">Minore</span>}
                        <DropdownMenu>
                          <DropdownMenuTrigger asChild>
                            {c.definita ? (
                              <button type="button" onClick={(e) => e.stopPropagation()} data-testid={`cliente-definita-badge-${i}`} title="Posizione definita — clicca per cambiare tipo o rimuovere"
                                className={`ml-2 inline-block text-[9px] font-bold uppercase tracking-wider rounded px-1.5 py-0.5 align-middle transition-colors ${defTipo(c).cls}`}>{defLabel(c)}</button>
                            ) : (
                              <button type="button" onClick={(e) => e.stopPropagation()} data-testid={`cliente-definita-toggle-${i}`} title="Segna posizione come definita"
                                className="ml-2 inline-block text-[9px] font-bold uppercase tracking-wider text-emerald-400/70 border border-dashed border-emerald-500/40 hover:bg-emerald-500/10 rounded px-1.5 py-0.5 align-middle opacity-0 group-hover/clirow:opacity-100 data-[state=open]:opacity-100 transition-opacity">Definita</button>
                            )}
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="start" onClick={(e) => e.stopPropagation()} data-testid={`cliente-definita-menu-${i}`}>
                            <DropdownMenuLabel className="text-xs">Tipo di definizione</DropdownMenuLabel>
                            {DEF_TIPI.map((t) => (
                              <DropdownMenuItem key={t.key} onSelect={() => toggleDefinita(i, t.key)} data-testid={`cliente-definita-opt-${i}-${t.key}`}>
                                <span className={`mr-2 inline-block h-2.5 w-2.5 rounded-full ${t.cls.split(" ").find((x) => x.startsWith("bg-"))}`} />{t.label}{c.definita && defTipo(c).key === t.key ? " ✓" : ""}
                              </DropdownMenuItem>
                            ))}
                            {c.definita && <><DropdownMenuSeparator /><DropdownMenuItem onSelect={() => toggleDefinita(i, null)} data-testid={`cliente-definita-remove-${i}`} className="text-red-500">Rimuovi definizione</DropdownMenuItem></>}
                          </DropdownMenuContent>
                        </DropdownMenu>
                        {c.cliente && (
                          <div className="mt-1">
                            <span data-testid={`cliente-badge-${i}`} className="inline-block text-[8px] font-bold uppercase tracking-wide text-sky-400/80 border border-sky-500/30 rounded px-1 py-px leading-tight">CLIENTE</span>
                          </div>
                        )}
                        {condPersonName(isPrincipal ? p.conducente : c.conducente) && (
                          <div className="mt-1 text-[11px] font-medium uppercase tracking-wide text-teal-300 flex items-center gap-2 flex-wrap" data-testid={`cliente-conducente-${i}`}>
                            Conducente: {condPersonName(isPrincipal ? p.conducente : c.conducente)}
                            <button type="button" onClick={(e) => { e.stopPropagation(); toggleCondCliente(i, c, isPrincipal); }} data-testid={`cliente-conducente-attiva-${i}`}
                              className={`normal-case tracking-normal text-[10px] font-semibold rounded px-1.5 py-0.5 border ${(isPrincipal ? p.conducente : c.conducente)?.come_cliente ? "border-teal-400 bg-teal-400/15 text-teal-200 hover:bg-teal-400/25" : "border-dashed border-teal-500/50 text-teal-300 hover:bg-teal-500/10"}`}>
                              {(isPrincipal ? p.conducente : c.conducente)?.come_cliente ? "Secondo cliente attivo · disattiva" : "Attiva come secondo cliente"}
                            </button>
                          </div>
                        )}
                      </td>
                      <td className="px-5 py-2.5 text-slate-300">{V(c.ruolo || "Assistito")}{c.targa && tFlags.veicolo ? <span className="text-slate-400 font-mono"> | {c.targa}</span> : null}</td>
                      <td className="px-3 py-2.5" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-center gap-1">
                          <button disabled={i === 0} onClick={() => moveClient(i, -1)} data-testid={`cliente-up-${i}`} title="Sposta su" className="p-1 rounded text-slate-400 hover:text-teal-300 disabled:opacity-30 disabled:cursor-not-allowed"><ChevronUp className="h-4 w-4" /></button>
                          <button disabled={i === clients.length - 1} onClick={() => moveClient(i, 1)} data-testid={`cliente-down-${i}`} title="Sposta giù" className="p-1 rounded text-slate-400 hover:text-teal-300 disabled:opacity-30 disabled:cursor-not-allowed"><ChevronDown className="h-4 w-4" /></button>
                        </div>
                      </td>
                    </tr>
                    {open && (
                      <tr data-testid={`cliente-detail-${i}`}>
                        <td colSpan={4} className="px-5 py-3 bg-slate-900/30">
                          <div data-testid={`cliente-detail-title-${i}`} className="mb-2 text-center text-base font-semibold uppercase tracking-wide text-teal-200">
                            {c.ragione_sociale || [c.cognome, c.nome].filter(Boolean).join(" ") || "Cliente"}
                          </div>
                          <div className="mb-1">
                            <CtxToolbar items={items} testId={`cliente-toolbar-${i}`} />
                          </div>
                          <ContattiInline fields={CLI_CONTATTI} values={cliVals(c)} onSave={(k, v) => saveClientContact(c, rawIdx, k, v)} testId={`cliente-contatti-${i}`} />
                          {!isPrincipal && (
                            <div className="mt-3 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-testid={`cliente-pro-fields-${i}`}>
                              <div className="sm:col-span-2 text-[11px] uppercase tracking-wider text-slate-500 font-mono">Professionisti di {c.ragione_sociale || "questo cliente"}</div>
                              {(c.da_conducente ? COND_PRO_FIELDS : PRO_FIELDS).map((pf) => (
                                <div key={pf.key}>
                                  <Label className="text-[11px] text-slate-400">{pf.label}</Label>
                                  <ProAnagField atype={pf.atype} label={pf.label} value={c[pf.key] || ""} compagnia={c.compagnia || c.assicurazione || ""}
                                    onlyFlag={{ assistito_perito_parte: "perito_di_parte", assistito_medico_legale: "medico_legale_di_parte", assistito_legale: "avvocato_di_parte" }[pf.key]}
                                    excludeFlag={pf.key === "assistito_perito_compagnia" ? "perito_di_parte" : undefined}
                                    onChange={(v) => persistClients(clients.map((x, k) => (k === i ? { ...x, [pf.key]: v } : x)))} testId={`cli${i}-${pf.key}`} />
                                </div>
                              ))}
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </Fragment>
                );
              })}
            </tbody>
          </table>
          <div className="px-5 py-3" data-testid="assistito-fields-edit">
            {!soloProf && <>
            <Field label="Compagnia Cliente" testId="pa-compagnia"><CompagniaPraticaInfo compagnia={compagniaAssistito} testId="pa-compagnia-info" /></Field>
            <AField label="Ispettorato / Sede" alt>
              <IspettoratoSelect compagnia={compagniaAssistito} value={ispettoratoAssistito} onChange={(v) => savePrimary("ispettorato", "assistito_ispettorato")(v)} testId="pa-ispettorato" />
            </AField>
            <AField label="Agenzia">
              <IspettoratoSelect kind="agenzie" compagnia={compagniaAssistito} value={(primaryClient ? assistiti[0]?.agenzia : "") || p.assistito_agenzia || ""} onChange={(v) => savePrimary("agenzia", "assistito_agenzia")(v)} testId="pa-agenzia" />
            </AField>
            <AField label="Numero di Sinistro" highlight={isRD}>
              <Input key={`nsin-${p.id}`} defaultValue={p.assistito_num_sinistro || ""} onBlur={(e) => { if ((e.target.value || "") !== (p.assistito_num_sinistro || "")) { saveField("assistito_num_sinistro", e.target.value); warnDuplicateSinistro(e.target.value, p.id); } }} data-testid="pa-num-sinistro" placeholder="Es. 123456/2026" className="h-9 w-full font-mono" />
            </AField>
            </>}
            {proFieldsVis.map((pf, idx) => (
              <Fragment key={pf.key}>
              <AField label={pf.label} alt={idx % 2 === 0}>
                <ProAnagField atype={pf.atype} label={pf.label} value={p[pf.key] || ""} compagnia={compagniaAssistito}
                  strictCompagnia={pf.key === "assistito_perito_compagnia"}
                  excludeFlag={pf.key === "assistito_perito_compagnia" ? "perito_di_parte" : undefined}
                  compagniaFilter={pf.key === "assistito_liquidatore"}
                  linkCompagnia={["assistito_liquidatore", "assistito_perito_compagnia", "assistito_accertatore"].includes(pf.key)}
                  onlyFlag={{ assistito_perito_parte: "perito_di_parte", assistito_medico_legale: "medico_legale_di_parte", assistito_legale: "avvocato_di_parte" }[pf.key]}
                  waCategory={{ assistito_liquidatore: "liquidatore", assistito_perito_compagnia: "perito_compagnia", assistito_accertatore: "accertatore", assistito_perito_parte: "perito_parte", assistito_medico_legale: "medico_legale", assistito_riparatore: "riparatore", assistito_legale: "avvocato" }[pf.key]}
                  onChange={(v) => saveField(pf.key, v)} testId={`pa-${pf.key}`} />
              </AField>
              {pf.key === "assistito_perito_compagnia" && (
                <CollaboratoreField atype="periti" professionista={p.assistito_perito_compagnia || ""} value={p.assistito_perito_compagnia_collaboratore || ""}
                  onChange={(v) => saveField("assistito_perito_compagnia_collaboratore", v)} testId="pa-assistito_perito_compagnia-collab" />
              )}
              </Fragment>
            ))}
            <AField label="Collab. Studio" alt>
              <CollabStudioField value={p.assistito_collaboratore_studio || ""} onChange={(v) => saveField("assistito_collaboratore_studio", v)} testId="pa-collaboratore-studio" />
            </AField>
            <AField label="Istruttore">
              <IstruttoreField value={p.assistito_istruttore || ""} onChange={(v) => saveField("assistito_istruttore", v)} testId="pa-istruttore" />
            </AField>
          </div>
        </div>

        {/* CONTROPARTI */}
        <div className="pgp-card pgp-sec pgp-sec-controparte overflow-hidden" data-testid="panel-controparte">
          <div className="px-5 py-3 border-b pgp-sec-controparte-head flex items-center justify-between">
            <span className="text-sm font-head font-bold text-orange-300 tracking-wide flex items-center gap-2 min-w-0">CONTROPARTI<CompagniaHead compagnia={controparti[0]?.compagnia || p.controparte_compagnia || ""} gest={!isRD} testId="controparte-head-compagnia" /></span>
            <button onClick={() => setCpDialog({ index: null, data: null })} data-testid="add-controparte-btn"
              className="flex items-center gap-1 text-xs text-orange-300 hover:text-orange-200 border border-orange-500/30 rounded-md px-2 py-1 transition-colors">
              <Plus className="h-3.5 w-3.5" /> Aggiungi
            </button>
          </div>
          {respSum > 100 && (
            <div className="px-5 py-2 flex items-center gap-2 bg-red-500/10 text-[#ff8a80] text-xs font-semibold border-b border-red-500/30" data-testid="controparti-resp-warning">
              <AlertTriangle className="h-4 w-4 shrink-0" /> La somma delle responsabilità supera il 100% (attuale: {respSum}%)
            </div>
          )}
          {controparti.length === 0 ? (
            <div className="px-5 py-6 text-center text-sm text-slate-500">Nessuna controparte. Usa "Aggiungi" per inserirne una.</div>
          ) : (
            controparti.map((cp, i) => (
              <div key={i} className="border-b border-slate-800 last:border-0" data-testid={`controparte-block-${i}`}>
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-left text-slate-500 text-[10px] uppercase tracking-wider font-mono border-b border-slate-800">
                      <th className="px-5 py-2">Ragione Sociale</th>
                      <th className="px-5 py-2">Ruolo</th>
                      {tFlags.veicolo && <th className="px-5 py-2">Targa</th>}
                      {!soloProf && <th className="px-5 py-2">Polizza</th>}
                    </tr>
                  </thead>
                  <tbody>
                    <tr onClick={() => setCpOpen((o) => ({ ...o, [i]: !o[i] }))} data-testid={`controparte-row-${i}`}
                      className={`cursor-pointer transition-colors ${cpOpen[i] ? "bg-orange-500/10" : "hover:bg-slate-800/40"}`}>
                      <td className="px-5 py-2.5 text-slate-100 font-medium uppercase">{(() => { const tel = (cp.telefono || cp.cellulare || "").trim(); if (!tel) return <span className="uppercase">{V(cp.ragione_sociale)}</span>; return (<TooltipProvider delayDuration={200}><Tooltip><TooltipTrigger asChild><span className="uppercase cursor-help underline decoration-dotted decoration-slate-500 underline-offset-2" data-testid={`controparte-nome-${i}`}>{V(cp.ragione_sociale)}</span></TooltipTrigger><TooltipContent side="top" align="start" className="bg-popover text-popover-foreground border border-border shadow-xl" data-testid={`controparte-tel-tooltip-${i}`}><div className="group/num flex items-center gap-1.5" data-testid={`controparte-tel-${i}`}><Phone className="h-3.5 w-3.5 text-amber-500" /><span className="font-mono">{tel}</span><CopyBtn value={tel} testId={`controparte-tel-copy-${i}`} /><WhatsAppLink number={tel} size="h-3.5 w-3.5" testId={`controparte-tel-wa-${i}`} text={waText} onOpen={(n) => waCtx.open({ numero: n, nome: cp.ragione_sociale || "", categoria: "controparte" })} /></div></TooltipContent></Tooltip></TooltipProvider>); })()}{cp.responsabile_principale && <span className="ml-2 inline-flex items-center rounded-full bg-orange-500 text-[#0a0d14] text-[9px] font-bold px-2 py-0.5 tracking-wide align-middle normal-case" data-testid={`controparte-resp-badge-${i}`}>RESP. PRINCIPALE</span>}<SoggettoBell pratiche={subjMatches(cp)} onOpen={openCollegata} testId={`controparte-bell-${i}`} />{(() => { const cn = condPersonName(i === 0 ? p.controparte_conducente : cp.conducente); return cn ? <div className="mt-1 text-[11px] font-medium uppercase tracking-wide text-teal-300" data-testid={`controparte-conducente-${i}`}>Conducente: {cn}</div> : null; })()}</td>
                      <td className="px-5 py-2.5 text-slate-300">{V(cp.ruolo || "Controparte")}</td>
                      {tFlags.veicolo && <td className="px-5 py-2.5 text-slate-300 font-mono">{V(cp.targa)}</td>}
                      {!soloProf && <td className="px-5 py-2.5 text-slate-300 font-mono">{V(cp.polizza)}</td>}
                    </tr>
                  </tbody>
                </table>
                {cpOpen[i] && <CtxToolbar items={cpActions(i)} testId={`controparte-toolbar-${i}`} />}
                {cpOpen[i] && <div className="px-5"><ContattiInline fields={CP_CONTATTI} values={cpVals(cp)} onSave={(k, v) => saveCpField(i, k, v)} testId={`controparte-contatti-${i}`} /></div>}
                <div className="px-5 py-3">
                  {controparti.length > 1 && (
                    <div className="grid grid-cols-2 gap-3 mb-3 pb-3 border-b border-slate-800">
                      <div>
                        <div className="text-slate-400 text-[10px] uppercase tracking-wider font-mono mb-1">Responsabilità %</div>
                        <Input type="number" min={0} max={100} defaultValue={cp.responsabilita_perc ?? ""}
                          onBlur={(e) => { const n = Math.max(0, Math.min(100, parseInt(e.target.value, 10) || 0)); saveCpNumber(i, "responsabilita_perc", n); }}
                          data-testid={`cp-${i}-responsabilita`} className="h-9 w-full font-mono" placeholder="0-100" />
                      </div>
                      <label className="flex items-end gap-2 cursor-pointer pb-1.5" data-testid={`cp-${i}-principale-wrap`}>
                        <Checkbox checked={!!cp.responsabile_principale} onCheckedChange={(v) => setCpPrincipale(i, !!v)} data-testid={`cp-${i}-principale`} />
                        <span className="text-xs text-slate-300">Responsabile principale</span>
                      </label>
                    </div>
                  )}
                  {!soloProf && <>
                  <Field label="Compagnia Controparte" testId={`cp-${i}-compagnia`}><CompagniaPraticaInfo compagnia={cp.compagnia || ""} testId={`cp-${i}-compagnia-info`} /></Field>
                  <AField label="Ispettorato / Sede">
                    <IspettoratoSelect compagnia={cp.compagnia || ""} value={cp.ispettorato || ""} onChange={(v) => saveCpField(i, "ispettorato", v)} testId={`cp-${i}-ispettorato`} />
                  </AField>
                  <AField label="Agenzia">
                    <IspettoratoSelect kind="agenzie" compagnia={cp.compagnia || ""} value={cp.agenzia || ""} onChange={(v) => saveCpField(i, "agenzia", v)} testId={`cp-${i}-agenzia`} />
                  </AField>
                  <AField label="Perito Compagnia">
                    <ProAnagField atype="periti" label="perito" waCategory="perito_compagnia" value={cp.perito_compagnia || ""} compagnia={cp.compagnia || ""} strictCompagnia linkCompagnia excludeFlag="perito_di_parte"
                      onChange={(v) => saveCpField(i, "perito_compagnia", v)} testId={`cp-${i}-perito_compagnia`} />
                  </AField>
                  <CollaboratoreField atype="periti" professionista={cp.perito_compagnia || ""} value={cp.perito_compagnia_collaboratore || ""}
                    onChange={(v) => saveCpField(i, "perito_compagnia_collaboratore", v)} testId={`cp-${i}-perito_compagnia-collab`} />
                  <AField label="Liquidatore">
                    <ProAnagField atype="liquidatori" label="liquidatore" waCategory="liquidatore" value={cp.liquidatore || ""} compagnia={cp.compagnia || ""} compagniaFilter linkCompagnia
                      onChange={(v) => saveCpField(i, "liquidatore", v)} testId={`cp-${i}-liquidatore`} />
                  </AField>
                  <AField label="Accertatore">
                    <ProAnagField atype="accertatori" label="Accertatore" waCategory="accertatore" value={cp.accertatore || ""} compagnia={cp.compagnia || ""} linkCompagnia
                      onChange={(v) => saveCpField(i, "accertatore", v)} testId={`cp-${i}-accertatore`} />
                  </AField>
                  <AField label="N° Sinistro Responsabile" highlight={!isRD}>
                    <Input defaultValue={cp.num_sinistro || ""} onBlur={(e) => { if ((e.target.value || "") !== (cp.num_sinistro || "")) warnDuplicateSinistro(e.target.value, p.id); saveCpField(i, "num_sinistro", e.target.value); }}
                      data-testid={`cp-${i}-num_sinistro`} className="h-9 w-full font-mono" placeholder="Es. 123456/2026" />
                  </AField>
                  </>}
                  <AField label="Medico Legale di Controparte">
                    <ProAnagField atype="medici_legali" label="medico legale" waCategory="medico_legale" value={cp.medico_legale || ""} compagnia={cp.compagnia || ""} excludeFlag="medico_legale_di_parte"
                      onChange={(v) => saveCpField(i, "medico_legale", v)} testId={`cp-${i}-medico_legale`} />
                  </AField>
                  <CollaboratoreField atype="medici_legali" professionista={cp.medico_legale || ""} value={cp.medico_legale_collaboratore || ""}
                    onChange={(v) => saveCpField(i, "medico_legale_collaboratore", v)} testId={`cp-${i}-medico_legale-collab`} />
                  {soloProf && (
                    <AField label="Legale di Controparte">
                      <ProAnagField atype="avvocati" label="legale" waCategory="avvocato" value={cp.legale || ""} excludeFlag="avvocato_di_parte"
                        onChange={(v) => saveCpField(i, "legale", v)} testId={`cp-${i}-legale`} />
                    </AField>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      </PraticaWaTextContext.Provider>

      {/* Diario / Messaggi */}
      <AllegatiDialog open={allegatiOpen} initialCategoria={allegatiCat} onOpenChange={(o) => { setAllegatiOpen(o); if (!o) setAllegatiCat(null); }} praticaId={p.id} praticaNumero={p.numero_pratica} assistitoName={allegatiClient?.ragione_sociale || assistitoLabel} assistitoKey={clientKey(allegatiClient)} onSendEmail={(att) => { setPecInitAtt(att); setPecClient(allegatiClient || clients[0] || null); setAllegatiOpen(false); setPecOpen(true); }} onComposeEmail={(att) => { setEmailInitAtt(att); setAllegatiOpen(false); setEmailOpen(true); }} />

      <WhatsAppDialog open={waOpen} onOpenChange={setWaOpen} praticaId={p.id} praticaNumero={p.numero_pratica} client={waClient} initialNumero={waNum} assistitoKey={clientKey(waClient)} clienteNome={assistitoLabel} />
      <WhatsAppDialog open={!!waSubject} onOpenChange={(o) => !o && setWaSubject(null)} praticaId={p.id} praticaNumero={p.numero_pratica}
        client={waSubject?.client || null} categoria={waSubject?.categoria || "cliente"}
        assistitoKey={waSubject ? `sogg:${waSubject.categoria}:${(waSubject.nome || "").trim().toLowerCase()}` : ""} defaultText={waText} clienteNome={assistitoLabel} />
      <CostiDialog open={costiOpen} onOpenChange={setCostiOpen} praticaId={p.id} />
      <QuietanzeDialog open={quietanzeOpen} onOpenChange={setQuietanzeOpen} praticaId={p.id} client={quietanzeClient?.__principal && (p.segnalatore || "").trim() ? { ...quietanzeClient, segnalatore: p.segnalatore } : quietanzeClient} onClientChange={saveClientConfig} />
      <GestioneLettereDialog open={lettereOpen} onOpenChange={setLettereOpen} pratica={p} assistitoKey={clientKey(lettereClient)} assistitoName={lettereClient?.ragione_sociale || assistitoLabel} />
      <DocumentoDialog open={!!doc} onOpenChange={(o) => !o && setDoc(null)} pratica={p} doc={doc} />
      <FatturaDialog open={fatturaOpen} onOpenChange={setFatturaOpen} pratica={p} />
      <ProformaListDialog open={proformaListOpen} onOpenChange={setProformaListOpen} pratica={p} client={proformaClient} clienteKey={proformaClientKey} />
      <ProformaDialog open={proformaOpen} onOpenChange={setProformaOpen} pratica={p} client={proformaClient} onSaved={(created) => { if (created) { api.get("/studio/me").then(({ data }) => { setProformaStudio(data); setPreviewProforma(created); }).catch(() => setPreviewProforma(created)); } }} />
      <ProformaPreviewDialog open={!!previewProforma} onOpenChange={(o) => !o && setPreviewProforma(null)} proforma={previewProforma} studio={proformaStudio} />
      <DiarioDialog open={diarioOpen} onOpenChange={setDiarioOpen} pratica={p} soggetto={diarioClient?.ragione_sociale || assistitoLabel} clienteKey={clientKey(diarioClient)} />
      <ControparteDialog
        open={!!cpDialog}
        onOpenChange={(o) => !o && setCpDialog(null)}
        initial={cpDialog?.data}
        conducenteEnabled={!!cpDialog}
        conducenteValue={cpDialog && (cpDialog.index === 0 || (cpDialog.index == null && controparti.length === 0)) ? p.controparte_conducente : cpDialog?.data?.conducente}
        dataSinistro={p.data_sinistro}
        onSave={(data) => saveControparte(data, cpDialog?.index)}
      />
      <AssistitoDialog
        open={!!aDialog}
        onOpenChange={(o) => !o && setADialog(null)}
        initial={aDialog?.data}
        conducenteEnabled={!!aDialog}
        conducenteValue={aDialog?.index === "principal" || (aDialog && aDialog.index == null && !principalEntry) ? p.conducente : aDialog?.data?.conducente}
        dataSinistro={p.data_sinistro}
        praticaId={p.id}
        onSave={(data) => saveAssistito(data, aDialog?.index)}
      />

      <AlertDialog open={!!delTarget} onOpenChange={(o) => { if (!o && !deleting) setDelTarget(null); }}>
        <AlertDialogContent className="bg-[#121824] border-slate-700 text-slate-100" data-testid="del-assistito-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-head text-slate-50">Elimina assistito</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-300">
              Sei sicuro di voler eliminare <strong className="text-slate-100">{delTarget?.name}</strong> da questa pratica? Verranno eliminati definitivamente tutti i dati collegati: anagrafica, diario, allegati, email e lettere generate. Questa operazione non può essere annullata.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={deleting} data-testid="del-assistito-cancel" className="border-slate-700 bg-slate-800/60 text-slate-200 hover:bg-slate-700">Annulla</AlertDialogCancel>
            <AlertDialogAction disabled={deleting} onClick={(e) => { e.preventDefault(); confirmDelAssistito(); }} data-testid="del-assistito-confirm" className="bg-red-600 hover:bg-red-700 text-white">
              {deleting ? "Eliminazione…" : "Elimina definitivamente"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <NuovoProfessionistaDialog open={!!proDialog} atype={proDialog?.atype} label={proDialog?.label} initialName={proDialog?.initialName} editRec={proDialog?.editRec} onCancel={() => handleProDone(false)} onSaved={(rec) => handleProDone(true, rec)} />
      <DatiSinistroDialog open={sinistroOpen} onOpenChange={setSinistroOpen} pratica={p} onSaved={(data) => { Object.assign(p, data); setProEdits((e) => ({ ...e })); }} />
      <QuantificazioneDialog open={quantOpen} onOpenChange={setQuantOpen} pratica={p} assistitoLabel={assistitoLabel} />
      <GestioneOffertaDialog open={offertaOpen} onOpenChange={setOffertaOpen} pratica={p} />
      <Dialog open={comunicazioniOpen} onOpenChange={(o) => { setComunicazioniOpen(o); if (!o) fetchComUnread(); }}>
        <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="comunicazioni-modal">
          <DialogHeader>
            <DialogTitle className="font-head">Comunicazioni · {assistitoLabel}</DialogTitle>
          </DialogHeader>
          <PraticaComunicazioni praticaId={p.id} praticaNumero={p.numero_pratica} />
        </DialogContent>
      </Dialog>
      <Dialog open={testimoniOpen} onOpenChange={setTestimoniOpen}>
        <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-4xl max-h-[88vh] overflow-y-auto" data-testid="testimoni-modal">
          <DialogHeader>
            <DialogTitle className="font-head flex items-center gap-2"><Users className="h-4 w-4 text-sky-400" /> Testimoni · {testimoni.length}</DialogTitle>
          </DialogHeader>
          <div className="rounded-md border border-slate-700 overflow-hidden" data-testid="panel-testimoni">
            <div className="px-5 py-3 border-b border-slate-800 flex items-center justify-between bg-slate-900/40">
              <span className="text-sm font-head font-bold text-sky-300 tracking-wide">TESTIMONI</span>
              <button onClick={() => setTDialog({ index: null, data: null })} data-testid="add-testimone-btn"
                className="flex items-center gap-1 text-xs text-sky-300 hover:text-sky-200 border border-sky-500/30 rounded-md px-2 py-1 transition-colors">
                <Plus className="h-3.5 w-3.5" /> Aggiungi
              </button>
            </div>
            {testimoni.length === 0 ? (
              <div className="px-5 py-6 text-center text-sm text-slate-500" data-testid="testimoni-empty">Nessun testimone. Usa "Aggiungi" per inserirne uno.</div>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-slate-500 text-[10px] uppercase tracking-wider font-mono border-b border-slate-800">
                    <th className="px-4 py-2 w-8">#</th>
                    <th className="px-4 py-2">Nominativo</th>
                    <th className="px-4 py-2">Ruolo</th>
                    <th className="px-4 py-2">Codice Fiscale</th>
                    <th className="px-4 py-2">Cellulare</th>
                    <th className="px-4 py-2">Comune</th>
                    <th className="px-4 py-2">Documento</th>
                    <th className="px-2 py-2 w-10" />
                  </tr>
                </thead>
                <tbody>
                  {testimoni.map((t, i) => (
                    <Fragment key={i}>
                      <tr onClick={() => setTOpen((o) => ({ ...o, [i]: !o[i] }))} data-testid={`testimone-row-${i}`}
                        className={`cursor-pointer transition-colors ${tOpen[i] ? "bg-sky-500/10" : `${i % 2 === 1 ? "bg-slate-500/10 " : ""}hover:bg-slate-800/40`}`}>
                        <td className="px-4 py-2.5 text-slate-500 font-mono">{i + 1}</td>
                        <td className="px-4 py-2.5 text-slate-100 font-medium uppercase">{testName(t)}</td>
                        <td className="px-4 py-2.5 text-slate-300">Testimone</td>
                        <td className="px-4 py-2.5 text-slate-300 font-mono">{V(t.codice_fiscale)}</td>
                        <td className="px-4 py-2.5 text-slate-300 font-mono">
                          <span className="inline-flex flex-wrap items-center gap-x-2.5 gap-y-1">{cellOptions(t).map((o, j) => (
                            <span key={o.n} className="inline-flex items-center gap-1">{o.n}{o.label && <span className="rounded bg-slate-700/40 px-1 py-px text-[10px]">{o.label}</span>}<WhatsAppLink number={o.n} size="h-3.5 w-3.5" testId={j ? `testimone-cell-wa-${i}-${j}` : `testimone-cell-wa-${i}`} /></span>
                          ))}{!cellOptions(t).length && V(t.cellulare)}</span>
                        </td>
                        <td className="px-4 py-2.5 text-slate-300">{V(t.comune)}</td>
                        <td className="px-4 py-2.5 text-slate-300">{V([t.tipo_documento, t.numero_documento].filter(Boolean).join(" "))}</td>
                        <td className="px-2 py-2.5 text-center">
                          <button type="button" onClick={(e) => { e.stopPropagation(); setTDialog({ index: i, data: t }); }} data-testid={`testimone-edit-${i}`}
                            title="Visualizza / modifica testimone" className="rounded p-1 text-slate-400 hover:text-amber-500 hover:bg-amber-500/10"><Pencil className="h-4 w-4" /></button>
                        </td>
                      </tr>
                      {tOpen[i] && (
                        <tr data-testid={`testimone-detail-${i}`}>
                          <td colSpan={8} className="p-0">
                            <CtxToolbar items={tActions(i)} testId={`testimone-toolbar-${i}`} />
                            <div className="px-5 py-3 grid sm:grid-cols-3 gap-x-6 gap-y-1 bg-slate-900/40">
                              {[["Sesso", t.sesso], ["Data nascita", formatDate(t.data_nascita)], ["Comune nascita", t.comune_nascita], ["Professione", t.professione], ["Telefono", t.telefono], ["Indirizzo", [t.indirizzo, t.numero_civico].filter(Boolean).join(" ")], ["CAP", t.cap], ["Provincia", t.provincia], ["Tipo documento", t.tipo_documento], ["Rilasciato da", t.documento_rilasciato_da]].map(([lab, val]) => (
                                <div key={lab} className="flex justify-between gap-2 border-b border-slate-800/60 py-1">
                                  <span className="text-slate-400 text-[11px] uppercase tracking-wider font-mono">{lab}</span>
                                  <span className="text-slate-100 text-right">{V(val)}</span>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <TestimoneDialog open={!!tDialog} onOpenChange={(o) => !o && setTDialog(null)} initial={tDialog?.data} onSave={(data) => saveTestimone(data, tDialog?.index)} />
      <PecDialog open={pecOpen} onOpenChange={setPecOpen} pratica={p} initialAttachments={pecInitAtt} clienteId={clientKey(pecClient)} soggetto={pecClient?.ragione_sociale || assistitoLabel} />
      <EmailDialog open={emailOpen} onOpenChange={setEmailOpen} pratica={p} initialAttachments={emailInitAtt} />

      {/* Messaggi con l'assistito — pannello laterale */}
      <Sheet open={messaggiOpen} onOpenChange={setMessaggiOpen}>
        <SheetContent className="bg-[#0d111a] border-slate-800 text-slate-100 w-full sm:max-w-lg overflow-y-auto" data-testid="messaggi-panel">
          <SheetHeader>
            <SheetTitle className="font-head text-slate-50 flex items-center gap-2">
              <MessageSquare className="h-4 w-4 text-amber-400" /> Messaggi · {assistitoLabel}
            </SheetTitle>
          </SheetHeader>
          <div className="mt-4">
            <MessageThread
              getUrl={`/studio/pratiche/${p.id}/messages`}
              postUrl={`/studio/pratiche/${p.id}/messages`}
              selfRole="studio"
            />
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
